
import React, { useEffect, useState, useRef, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Select from "react-select";
import ProcedureBillModal from '../models/ProcedureBillModal';
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode';
import { loadFontAsBase64 } from "../loadFont";
import DoctorAppointmentSlot from '../comps/DoctorAppointmentSlot';



function OpdPataintList() {
const todayDate = (() => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
})();
const [activeRegTab, setActiveRegTab] = useState('registration');
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [headerLogo, setHeaderLogo] = useState('');
  const [watermarkLogo, setWatermarkLogo] = useState('');
  const [footerImage, setFooterImage] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [doctorsMap, setDoctorsMap] = useState({});
  const [showProcedureBill, setShowProcedureBill] = useState(false);
  const [procedurePatientData, setProcedurePatientData] = useState(null);
  const dropdownRefs = useRef([]);
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [appointmentMap, setAppointmentMap] = useState({});


  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentPatient, setPaymentPatient] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState('');
  const [paymentMode, setPaymentMode] = useState('Cash');
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [opdRefundMap, setOpdRefundMap] = useState({});


  // Refund states for OPD
const [showOpdRefundModal, setShowOpdRefundModal] = useState(false);
const [opdRefundPatient, setOpdRefundPatient] = useState(null);
const [opdRefundAmount, setOpdRefundAmount] = useState('');
const [opdRefundMode, setOpdRefundMode] = useState('');
const [opdRefundRemarks, setOpdRefundRemarks] = useState('');
const [opdRefundedBy, setOpdRefundedBy] = useState('');
const [opdRefundProcessing, setOpdRefundProcessing] = useState(false);
const [opdRefundHistory, setOpdRefundHistory] = useState([]);

// ============================================================
// ✅ LAB REPORT STATES
// ============================================================
// Map: uhid => array of lab registrations (sorted newest first)
const [labRegsByUhid, setLabRegsByUhid] = useState({});
const [labDataLoading, setLabDataLoading] = useState(false);

// Lab report test selection modal
const [showLabReportModal, setShowLabReportModal] = useState(false);
const [labReportModalData, setLabReportModalData] = useState(null); // { patient, labReg, tests }
const [labReportSelectedTests, setLabReportSelectedTests] = useState([]);
const [labReportSelectAll, setLabReportSelectAll] = useState(false);

// When multiple lab regs exist for same UHID — picker modal
const [showLabRegPickerModal, setShowLabRegPickerModal] = useState(false);
const [labRegPickerList, setLabRegPickerList] = useState([]);
const [labRegPickerOpdRow, setLabRegPickerOpdRow] = useState(null);

// Lab config for PDF (signatures, departments)
const [labDeparts, setLabDeparts] = useState([]);
const [labSignData, setLabSignData] = useState({});
const [labConfigImage, setLabConfigImage] = useState('');
const [labConfigWatermark, setLabConfigWatermark] = useState('');
const [labConfigFooter, setLabConfigFooter] = useState('');
const [labName, setLabName] = useState('');

  const [formData, setFormData] = useState({
    l1: [],
    doc: [],
    page_no: 0,
    from: todayDate,
    to: todayDate,
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
    selectedDoctorId: '' 
  });

  const [totals, setTotals] = useState({
    totalAmount: 0,
    discountAmount: 0,
    paidAmount: 0,
    dueAmount: 0,
    totalCharges: 0
  });

const navigate = useNavigate();
// ✅ Helper to attach logged-in user info to any FormData
const attachUserInfo = (fd) => {
  try {
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      const u = JSON.parse(stored);
      fd.append('user_id',   u.user_id   || '');
      fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
      fd.append('user_role', u.role_id   || u.role_name || '');
    }
  } catch (e) {
    console.warn("attachUserInfo failed:", e);
  }
  return fd;
};
// ============================================================
// ✅ LAB DATA FETCHING
// ============================================================
const fetchLabDataForOpdPatients = async () => {
  try {
    setLabDataLoading(true);
    const fd = new FormData();
    fd.append('page_no', 'none');
    fd.append('search_key', '');
    fd.append('lab_reg_user', 'all');
    if (formData.from) fd.append('from', formData.from + " 00:00:00");
    if (formData.to) fd.append('to', formData.to + " 23:59:59");

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getLabRegListUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response?.data?.status && Array.isArray(response.data.records)) {
      const records = response.data.records;


      const byUhid = {};
      
      records.forEach(rec => {
        const uhid = (rec.lab_reg_uhid || '').toString().trim();
        if (!uhid) return;
        if (!byUhid[uhid]) byUhid[uhid] = [];
        byUhid[uhid].push(rec);
      });

      // Sort each UHID's registrations by date descending (newest first)
      Object.keys(byUhid).forEach(uhid => {
        byUhid[uhid].sort((a, b) => {
          const dA = new Date(a.lab_reg_datetime || a.lab_reg_date || 0);
          const dB = new Date(b.lab_reg_datetime || b.lab_reg_date || 0);
          return dB.getTime() - dA.getTime();
        });
      });
      
      console.log("✅ Lab data fetched for", Object.keys(byUhid).length, "UHIDs");
      setLabRegsByUhid(byUhid);
    } else {
      setLabRegsByUhid({});
    }
  } catch (err) {
    console.error("fetchLabDataForOpdPatients error:", err);
    setLabRegsByUhid({});
  } finally {
    setLabDataLoading(false);
  }
};

// Fetch lab config (header/footer images, departments, signatures) — once on mount
const fetchLabConfig = async () => {
  try {
    // 1. Config images
    const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
    if (res.data && res.data.status) {
      setLabConfigImage(res.data.header_logo || '');
      setLabConfigWatermark(res.data.logo || '');
      setLabConfigFooter(res.data.footer_logo || '');
    }
  } catch (err) {
    console.warn("fetchLabConfig images error:", err);
  }

  // 2. Departments
  try {
    const fd = new FormData();
    fd.append('cat_type', 'department');
    fd.append('page_no', 'none');
    fd.append('search_key', '');
    fd.append('par_by', '1');
    const dRes = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd);
    if (dRes.data.status && dRes.data.records) {
      setLabDeparts(dRes.data.records);
      // 3. Sign config for each department
      const signMap = {};
      for (const dep of dRes.data.records) {
        try {
          const sfd = new FormData();
          sfd.append('sign_department', String(dep.cat_id));
          const sRes = await axios.post(AppConst.BASE_URL + AppConst.getSignByDepartUrl, sfd);
          if (sRes.data && sRes.data.status && sRes.data.sign_dt) {
            signMap[dep.cat_id] = sRes.data.sign_dt;
          }
        } catch (e) {}
      }
      setLabSignData(signMap);
    }
  } catch (err) {
    console.warn("fetchLabConfig departments error:", err);
  }

  // User name
  const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
  setLabName([storedDataF?.fname, storedDataF?.lname].filter(Boolean).join(" "));
};

// Get lab registrations for an OPD row
const getLabRegsForOpdRow = (opdRow) => {
  if (!opdRow) return [];
  const uhid = (opdRow.opd_uhid || '').toString().trim();
  if (!uhid) return [];
  return labRegsByUhid[uhid] || [];
};

// Get the "best" (most recent) lab reg for status display
const getLatestLabReg = (opdRow) => {
  const regs = getLabRegsForOpdRow(opdRow);
  return regs.length > 0 ? regs[0] : null;
};

// Open OPD refund modal
const handleOpenOpdRefund = (patient) => {
  const paid = parseFloat(patient.opd_paid || 0);
  if (paid <= 0) {
    toast.info('No paid amount to refund for this patient');
    return;
  }
  
  setOpdRefundPatient(patient);
  setOpdRefundAmount('');
  setOpdRefundMode('');
  setOpdRefundRemarks('');
  const userName = `${loggedUser?.fname || ''} ${loggedUser?.lname || ''}`.trim();
  setOpdRefundedBy(userName || 'User');
  fetchOpdRefundHistory(patient.opd_id);
  setShowOpdRefundModal(true);
};

// Fetch OPD refund history
const fetchOpdRefundHistory = async (opdId) => {
  try {
    const fd = new FormData();
    fd.append('opd_id', opdId);
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getOpdRefundHistoryUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    if (response.data.status) {
      setOpdRefundHistory(response.data.records || []);
    }
  } catch (error) {
    console.error("Error fetching OPD refund history:", error);
    setOpdRefundHistory([]);
  }
};

// Process OPD refund
const handleProcessOpdRefund = async () => {
  const amt = parseFloat(opdRefundAmount || 0);
  const paid = parseFloat(opdRefundPatient?.opd_paid || 0);
  
  // Validations
  if (!opdRefundMode || opdRefundMode.trim() === '') {
    toast.error('Please select refund mode');
    return;
  }
  
  if (amt <= 0) {
    toast.error('Enter a valid refund amount');
    return;
  }
  
  if (amt > paid) {
    toast.error(`Refund cannot exceed paid amount (₹${paid.toFixed(2)})`);
    return;
  }
  
  if (!opdRefundRemarks || opdRefundRemarks.trim() === '') {
    toast.error('Remarks are mandatory for refund');
    return;
  }
  
  // Confirm
  const confirm = await Swal.fire({
    title: 'Confirm Refund?',
    html: `
      <div style="text-align: left; padding: 10px;">
        <p><strong>Patient:</strong> ${opdRefundPatient.opd_patient_name}</p>
        <p><strong>Refund Amount:</strong> ₹${amt.toFixed(2)}</p>
        <p><strong>Mode:</strong> ${opdRefundMode}</p>
        <p><strong>Remarks:</strong> ${opdRefundRemarks}</p>
      </div>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc3545',
    confirmButtonText: 'Yes, Refund',
    customClass: { container: 'swal2-on-top-of-modal' }  // ✅ ADD THIS
  });
  
  if (!confirm.isConfirmed) return;
  
  setOpdRefundProcessing(true);
  
  try {
    const fd = new FormData();
    fd.append('opd_id', opdRefundPatient.opd_id);
    fd.append('refund_amount', amt);
    fd.append('refund_mode', opdRefundMode);
    fd.append('refund_remarks', opdRefundRemarks);
    fd.append('refunded_by', opdRefundedBy);
    fd.append('user_id', loggedUser?.user_id || '1');
    attachUserInfo(fd);
    
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.opdRefundUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    
    if (res.data?.status) {
      toast.success(res.data.message || 'Refund processed successfully');
      if (res.data.refund_map) {
        setOpdRefundMap(res.data.refund_map);
      }
      // Update local state
      // setFormData(prev => ({
      //   ...prev,
      //   l1: prev.l1.map(p =>
      //     p.opd_id === opdRefundPatient.opd_id
      //       ? { ...p, opd_paid: res.data.new_paid, opd_due: res.data.new_due }
      //       : p
      //   )
      // }));
      
      setOpdRefundPatient(prev => ({
        ...prev,
        opd_paid: res.data.new_paid,
        opd_due: res.data.new_due
      }));
      
      // Clear form
      setOpdRefundAmount('');
      setOpdRefundRemarks('');
      setOpdRefundMode('');
      
      fetchOpdRefundHistory(opdRefundPatient.opd_id);
      setTimeout(() => initData(), 500);
      setTimeout(() => setShowOpdRefundModal(false), 1500);
    } else {
      toast.error(res.data?.message || 'Refund failed');
    }
  } catch (err) {
    console.error('OPD Refund error:', err);
    toast.error('Error processing refund');
  } finally {
    setOpdRefundProcessing(false);
  }
};
// ============================================================
// ✅ LAB REPORT: Open flow when user clicks print icon
// ============================================================
const handleLabReportClick = async (opdRow) => {
  const labRegs = getLabRegsForOpdRow(opdRow);
  
  if (labRegs.length === 0) {
    toast.info("No lab registration found for this patient.");
    return;
  }

  if (labRegs.length === 1) {
    // Single registration → directly open test selection
    await openLabTestSelectionModal(opdRow, labRegs[0]);
  } else {
    // Multiple registrations → show picker modal
    setLabRegPickerList(labRegs);
    setLabRegPickerOpdRow(opdRow);
    setShowLabRegPickerModal(true);
  }
};


const fetchAppointmentsForDate = async (fromDate, toDate) => {
  try {
    // Fetch bookings for entire date range instead of single date
    const map = {};
    const startDate = new Date(fromDate || todayDate);
    const endDate = new Date(toDate || fromDate || todayDate);
    
    // Loop through each date in range
    const dates = [];
    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      dates.push(`${y}-${m}-${dd}`);
    }

    // Fetch all bookings in parallel
    await Promise.all(dates.map(async (dateStr) => {
      const fd = new FormData();
      fd.append('action', 'get_bookings');
      fd.append('date', dateStr);
      
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.doctorSlotUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (res.data?.status && Array.isArray(res.data.records)) {
        res.data.records.forEach(b => {
          const opdId = String(b.booking_opd_id || '');
          if (opdId) map[opdId] = b;
        });
      }
    }));
    
    setAppointmentMap(map);
  } catch (err) {
    console.error('fetchAppointments error:', err);
    setAppointmentMap({});
  }
};
// Fetch tests with saved results for a specific lab registration
const fetchLabTestsWithResults = async (labRegId) => {
  try {
    const fd = new FormData();
    fd.append('page_no', 'none');
    fd.append('search_key', '');
    fd.append('lab_item_parent', String(labRegId));

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd,
      { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 20000 }
    );

    if (!response.data?.status || !Array.isArray(response.data.records)) {
      return [];
    }

    return response.data.records.map((rec, idx) => {
      let interp = (rec.interpretation && String(rec.interpretation).trim()) ? rec.interpretation : "";
      if (!interp && rec.test_interpretation) interp = rec.test_interpretation;
      if (!interp && rec.test_interpratation) interp = rec.test_interpratation;
      if (!interp && Array.isArray(rec.params) && rec.params.length > 0) {
        for (const p of rec.params) {
          if (p.test_interpretation && String(p.test_interpretation).trim()) { interp = p.test_interpretation; break; }
          if (p.test_interpratation && String(p.test_interpratation).trim()) { interp = p.test_interpratation; break; }
        }
      }

      const normalizedParams = (rec.params || []).map(p => ({
        ...p,
        result: p.result || p.test_result || p.lab_item_result || '',
        test_param_name: p.test_param_name || p.param_name || '',
        test_param_type: p.test_param_type || 'Text',
        test_range_type: p.test_range_type || '',
        test_param_from_range: p.test_param_from_range || '',
        test_param_to_range: p.test_param_to_range || '',
        test_param_method: p.test_param_method || '',
        test_sample_type: p.test_sample_type || rec.test_sample_type || '',
        test_cat: p.test_cat || rec.test_cat || ''
      }));

      return {
        ...rec,
        id: rec.lab_item_test_id || rec.lab_item_id || rec.id || `test-${idx}`,
        lab_item_test_name: rec.lab_item_test_name || rec.test_name || rec.name || `Test ${idx + 1}`,
        params: normalizedParams,
        test_cat: normalizedParams[0]?.test_cat || rec.test_cat || '',
        test_sample_type: normalizedParams[0]?.test_sample_type || rec.test_sample_type || '',
        interpretation: interp ? String(interp) : "",
        impression: rec.impression || '',
        notes: rec.notes || '',
        report_info: rec.report_info || {
          test_report_id: rec.test_report_id || null,
          is_approved: rec.is_approved || "0"
        }
      };
    });
  } catch (err) {
    console.error("fetchLabTestsWithResults error:", err);
    return [];
  }
};

// Open test selection modal for a specific lab registration
const openLabTestSelectionModal = async (opdRow, labReg) => {
  Swal.fire({
    title: 'Loading test results...',
    text: 'Please wait',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  const tests = await fetchLabTestsWithResults(labReg.lab_reg_id);
  Swal.close();

  if (tests.length === 0) {
    toast.error("No test results found. Please save results in Report Entry first.");
    return;
  }

  // Build patient object from labReg for PDF
  const patientForPdf = {
    ...labReg,
    lab_reg_id: labReg.lab_reg_id,
    lab_reg_uhid: labReg.lab_reg_uhid || opdRow.opd_uhid,
    lab_reg_name: labReg.lab_reg_name || opdRow.opd_patient_name,
    lab_reg_name_title: labReg.lab_reg_name_title || opdRow.opd_patient_title || '',
    lab_reg_gender: labReg.lab_reg_gender || opdRow.opd_patient_gender,
    lab_reg_age_year: labReg.lab_reg_age_year || opdRow.opd_guardien_years || opdRow.opd_patient_age || '0',
    lab_reg_age_month: labReg.lab_reg_age_month || opdRow.opd_guardien_months || '0',
    lab_reg_age_day: labReg.lab_reg_age_day || '0',
    lab_reg_referral: labReg.lab_reg_referral || opdRow.consult_doctor_name || '',
    lab_reg_date: labReg.lab_reg_date || '',
    lab_reg_mobile: labReg.lab_reg_mobile || opdRow.opd_patient_mobile || '',
    lab_collected_at: labReg.lab_collected_at || ''
  };

  setLabReportModalData({ patient: patientForPdf, labReg, tests });
  setLabReportSelectedTests(tests.map(t => String(t.id)));
  setLabReportSelectAll(true);
  setShowLabRegPickerModal(false);
  setShowLabReportModal(true);
};

// Toggle test selection
const handleLabTestToggle = (testId) => {
  const id = String(testId);
  setLabReportSelectedTests(prev => {
    const next = prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id];
    setLabReportSelectAll(
      labReportModalData?.tests?.length > 0 &&
      next.length === labReportModalData.tests.length
    );
    return next;
  });
};

const handleLabTestSelectAll = () => {
  if (labReportSelectAll) {
    setLabReportSelectedTests([]);
    setLabReportSelectAll(false);
  } else {
    setLabReportSelectedTests((labReportModalData?.tests || []).map(t => String(t.id)));
    setLabReportSelectAll(true);
  }
};

// Print selected tests
const handleLabReportPrint = async () => {
  if (!labReportModalData || labReportSelectedTests.length === 0) {
    toast.error("Please select at least one test.");
    return;
  }

  const testsToPrint = labReportModalData.tests.filter(t =>
    labReportSelectedTests.includes(String(t.id))
  );

  if (testsToPrint.length === 0) {
    toast.error("No tests selected.");
    return;
  }

  Swal.fire({
    title: 'Generating PDF...',
    text: 'Please wait...',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    await generateLabReportPdf(testsToPrint, labReportModalData.patient);
    Swal.close();
    setShowLabReportModal(false);
  } catch (err) {
    Swal.close();
    console.error("PDF generation error:", err);
    toast.error("Failed to generate PDF.");
  }
};


// ============================================================
// ✅ PDF GENERATION (same logic as LabRegistrations/ReportEntry)
// ============================================================
const _imageCache = {};
const imageUrlToBase64 = async (url) => {
  if (!url) return null;
  if (_imageCache[url]) return _imageCache[url];
  try {
    const response = await fetch(url, { cache: 'no-cache', mode: 'cors' });
    if (!response.ok) return null;
    const blob = await response.blob();
    if (!blob.type.startsWith('image/')) return null;
    const result = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    _imageCache[url] = result;
    return result;
  } catch (err) {
    console.error("imageUrlToBase64 error:", url, err);
    return null;
  }
};

const addLabHeaderAndFooter = async (doc) => {
  const pw = doc.internal.pageSize.getWidth();
  const ph = doc.internal.pageSize.getHeight();
  try {
    const wm = await imageUrlToBase64(labConfigWatermark);
    if (wm && typeof doc.setGState === 'function') {
      doc.setGState(new doc.GState({ opacity: 0.08 }));
      doc.addImage(wm, 'PNG', (pw - 120) / 2, (ph - 120) / 2, 120, 120);
      doc.setGState(new doc.GState({ opacity: 1 }));
    }
  } catch (e) {}
  try { const h = await imageUrlToBase64(labConfigImage); if (h) doc.addImage(h, 0, 0, pw, 30); } catch(e) {}
  try { const f = await imageUrlToBase64(labConfigFooter); if (f) doc.addImage(f, 0, ph - 13, pw, 13); } catch(e) {}
};

const getAgeDisplay = (p) => {
  if (!p) return 'N/A';
  const y = Number(p.lab_reg_age_year || 0);
  const m = Number(p.lab_reg_age_month || 0);
  const d = Number(p.lab_reg_age_day || 0);
  if (y === 0 && m === 0 && d === 0) return 'N/A';
  const parts = [];
  if (y > 0) parts.push(`${y}Y${y > 1 ? 's' : ''}`);
  if (m > 0) parts.push(`${m}M${m > 1 ? 's' : ''}`);
  if (d > 0) parts.push(`${d}D${d > 1 ? 's' : ''}`);
  return parts.join(' ');
};

const formatDateTime12h = (dateTimeStr) => {
  if (!dateTimeStr) return "";
  try {
    const d = new Date(dateTimeStr);
    if (isNaN(d.getTime())) return dateTimeStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}-${month}-${year} ${String(hours).padStart(2,"0")}:${minutes}:${seconds} ${ampm}`;
  } catch (e) { return dateTimeStr; }
};

const printLabPatientDetails = async (doc, patient = {}, startY = 40) => {
  try {
    startY = Number(startY); if (!isFinite(startY)) startY = 40;
    const pw = doc.internal.pageSize.getWidth();
    const PAGE_WIDTH = isFinite(pw) ? pw : 210;
    const boxLeft = 10, boxTop = startY - 2, boxWidth = PAGE_WIDTH - 20, boxHeight = 24;
    doc.setDrawColor(0,0,0); doc.setLineWidth(0.2); doc.rect(boxLeft, boxTop, boxWidth, boxHeight);

    // QR
    const qrSize = 18, qrX = boxLeft + boxWidth - qrSize - 3, qrY = boxTop + 2;
    try {
      const qrUrl = `${window.location.origin}/qr-report/${patient.lab_reg_id}`;
      const qrDataUrl = await QRCode.toDataURL(qrUrl, { width: 200, margin: 1 });
      if (qrDataUrl) doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
    } catch (e) {}

    const dateParts = String(patient.lab_reg_date || "").split("-");
    const formattedDate = (dateParts.length >= 3) ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}` : (patient.lab_reg_date || "");
    const reportedOn = formatDateTime12h(new Date().toISOString());
    const printedOn = formatDateTime12h(new Date().toISOString());
    const lL = boxLeft + 4, lV = lL + 36, rL = boxLeft + Math.round(boxWidth * 0.5) + 4, rV = rL + 36;
    let yP = boxTop + 5;
    doc.setFontSize(10);

    doc.setFont('helvetica','bold'); doc.text("UHID", lL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${patient.lab_reg_uhid||''}`, lV, yP);
    doc.setFont('helvetica','bold'); doc.text("Patient ID", rL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: 00${patient.lab_reg_id||''}`, rV, yP);
    yP += 4;
    doc.setFont('helvetica','bold'); doc.text("Patient Name", lL, yP);
    const titleP = patient.lab_reg_name_title ? String(patient.lab_reg_name_title).trim() + ' ' : '';
    doc.setFont('helvetica','normal'); doc.text(`: ${titleP}${patient.lab_reg_name||''}`, lV, yP);
    doc.setFont('helvetica','bold'); doc.text("Registered On", rL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${formattedDate}`, rV, yP);
    yP += 4;
    doc.setFont('helvetica','bold'); doc.text("Age / Gender", lL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${getAgeDisplay(patient)} / ${patient.lab_reg_gender||''}`, lV, yP);
    doc.setFont('helvetica','bold'); doc.text("Collected At", rL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${patient.lab_collected_at||''}`, rV, yP);
    yP += 4;
    doc.setFont('helvetica','bold'); doc.text("Referred By", lL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${patient.lab_reg_referral||'N/A'}`, lV, yP);
    doc.setFont('helvetica','bold'); doc.text("Sample By", rL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${labName||''}`, rV, yP);
    yP += 4;
    doc.setFont('helvetica','bold'); doc.text("Reported On", lL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${reportedOn}`, lV, yP);
    doc.setFont('helvetica','bold'); doc.text("Printed On", rL, yP);
    doc.setFont('helvetica','normal'); doc.text(`: ${printedOn}`, rV, yP);

    return boxTop + boxHeight + 10;
  } catch (err) {
    console.error("printLabPatientDetails error:", err);
    return Number(startY) + 9;
  }
};

async function addLabSignatures(doc, signData) {
  const finalY = doc.internal.pageSize.getHeight() - 45;
  if (!signData) return;
  if (signData.sign_tech_sign) {
    try {
      const b = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_tech_sign);
      if (b) doc.addImage(b, 'PNG', 14, finalY, 30, 15);
    } catch(e){}
    if (signData.sign_tech_name) {
      doc.setFontSize(9).setFont('helvetica','normal').text(`${signData.sign_tech_name}${signData.sign_tech_id ? ` (${signData.sign_tech_id})` : ''}`, 14, finalY+20);
      doc.setFontSize(9).setFont('helvetica','bold').text("Lab Technician", 14, finalY+24);
    }
  }
  if (signData.sign_doc_sign || signData.sign_doc_name) {
    if (signData.sign_doc_sign) {
      try {
        const b = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_doc_sign);
        if (b) doc.addImage(b, 'PNG', 166, finalY, 30, 15);
      } catch(e){}
    }
    if (signData.sign_doc_name) {
      doc.setFontSize(11).setFont('helvetica','bold').text(`${signData.sign_doc_name}${signData.sign_doc_id ? ` (${signData.sign_doc_id})` : ''}`, 196, finalY+20, { align:'right' });
      let designation = signData.sign_doc_spec || signData.sign_doc_quali || 'Consultant';
      doc.setFontSize(9).setFont('helvetica','bold').text(designation, 196, finalY+24, { align:'right' });
    }
  }
}

const formatCellValue = (htmlString) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  const table = tempDiv.querySelector("table");
  if (table) {
    let rows = [];
    for (const tr of table.querySelectorAll("tr")) {
      let cells = [];
      for (const td of tr.querySelectorAll("td")) cells.push(td.innerText.trim());
      rows.push(cells.join(" | "));
    }
    return rows.join("\n");
  }
  return tempDiv.innerText.trim();
};

const get_param_val = (tmp) => {
  if (!tmp) return "";
  const type = (tmp.test_param_type || "").trim();
  if (type === "Numeric") {
    const from = tmp.test_param_from_range ?? "";
    const to = tmp.test_param_to_range ?? "";
    if (from === "" && to === "") return "";
    if (from !== "" && to !== "") return `${from} - ${to}`;
    return from !== "" ? `${from}` : `${to}`;
  }
  if (type === "Boolean") return tmp.test_param_from_range || "Yes / No";
  return tmp.test_param_from_range || "";
};

const drawHtmlContent = async (doc, htmlString, initialX, initialY, options) => {
  const { maxWidth, addNewPage, pageHeight, pageBuffer } = options;
  let x = initialX, y = initialY;
  const styleStack = [{ font:'helvetica', style:'normal', size:9 }];
  const applyStyle = () => { const s = styleStack[styleStack.length-1]; doc.setFontSize(s.size); doc.setFont(s.font, s.style); };
  const parseNodes = async (nodes) => {
    for (const node of nodes) {
      if (y > pageHeight - pageBuffer) { y = await addNewPage(); }
      if (node.nodeType === 3) {
        const text = node.nodeValue.trim(); if (!text) continue;
        const words = text.split(/\s+/);
        for (const word of words) {
          const ww = doc.getTextWidth(word + ' ');
          if (x + ww > initialX + maxWidth) { x = initialX; y += 5; if (y > pageHeight - pageBuffer) y = await addNewPage(); }
          applyStyle(); doc.text(word, x, y); x += ww;
        }
        if (x > initialX) x += doc.getTextWidth(' ');
      } else if (node.nodeType === 1) {
        const tag = node.tagName.toUpperCase();
        let ns = { ...styleStack[styleStack.length-1] }; let isBlock = false;
        switch(tag) {
          case 'STRONG': case 'B': ns.style='bold'; break;
          case 'EM': case 'I': ns.style='italic'; break;
          case 'P': if (x > initialX) { y += 8; x = initialX; } isBlock = true; break;
          case 'LI': if (x > initialX) y += 6; x = initialX; applyStyle(); doc.text('• ', x, y); x += 5; isBlock = true; break;
          case 'UL': case 'OL': if (x > initialX) { y += 8; x = initialX; } isBlock = true; break;
        }
        styleStack.push(ns); await parseNodes(node.childNodes); styleStack.pop();
        if (isBlock) { x = initialX; y += 5; }
      }
    }
  };
  const tempDiv = document.createElement("div"); tempDiv.innerHTML = htmlString;
  await parseNodes(tempDiv.childNodes);
  return y;
};

const generateLabReportPdf = async (testsToPrint, patient) => {
  const doc = new jsPDF();
  let hasRadiology = false;

  try {
    const fontBase64 = await loadFontAsBase64("/DejaVuSans.ttf");
    doc.addFileToVFS("DejaVuSans.ttf", fontBase64);
    doc.addFont("DejaVuSans.ttf", "DejaVu", "normal");
    doc.setFont("DejaVu");
  } catch (e) { console.warn("Font loading failed:", e); }

  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const SIGNATURE_AREA_HEIGHT = 45;
  const SAFE_BOTTOM = pageHeight - SIGNATURE_AREA_HEIGHT;
  let lastPrintedDeptOnCurrentPage = null;

  const addNewPage = async () => {
    doc.addPage();
    lastPrintedDeptOnCurrentPage = null;
    await addLabHeaderAndFooter(doc);
    return await printLabPatientDetails(doc, patient, 35);
  };

  const hasSpace = (needed) => yPos + needed <= SAFE_BOTTOM;

  const printDepartmentHeader = (deptName) => {
    doc.setFillColor(180, 220, 250);
    doc.rect(10, yPos - 5, 190, 8, 'FD');
    doc.setFontSize(12).setFont('helvetica','bold').setTextColor(0,0,0);
    doc.text(deptName, 105, yPos, { align:'center' });
    yPos += 8;
    lastPrintedDeptOnCurrentPage = deptName;
  };

  await addLabHeaderAndFooter(doc);
  let yPos = await printLabPatientDetails(doc, patient, 35);

  const departmentMap = {};
  (labDeparts || []).forEach(d => { departmentMap[d.cat_id] = d.cat_name; });

  const getDeptName = (test) => {
    if (test.params && test.params.length > 0) return departmentMap[test.params[0].test_cat] || "HEMATOLOGY";
    return "HEMATOLOGY";
  };

  const hasAnyPrintableContent = (test) => {
    if (!test.params || test.params.length === 0) return false;
    return test.params.some(param => {
      if (param.test_param_type === "Editor") return param.result && String(param.result).trim() !== '';
      const rawName = String(param.test_param_name || "").trim();
      if (/^\*.+\*$/.test(rawName)) return false;
      return param.result !== undefined && param.result !== null && String(param.result).trim() !== '';
    });
  };

  const sortedTests = [...testsToPrint].sort((a, b) => getDeptName(a).toUpperCase().localeCompare(getDeptName(b).toUpperCase()));

  for (const test of sortedTests) {
    if (!hasAnyPrintableContent(test)) continue;
    let deptName = getDeptName(test);
    if (deptName && deptName.toLowerCase() === "radiology") hasRadiology = true;

    const needsDeptHeader = deptName && deptName !== lastPrintedDeptOnCurrentPage;
    const deptH = needsDeptHeader ? 15 : 0;
    if (!hasSpace(deptH + 50)) yPos = await addNewPage();

    let addTableHead = false;
    if (needsDeptHeader) {
      if (!hasSpace(deptH + 50)) yPos = await addNewPage();
      printDepartmentHeader(deptName);
      addTableHead = true;
    }
    if (!hasSpace(40)) { yPos = await addNewPage(); if (deptName && deptName !== lastPrintedDeptOnCurrentPage) { printDepartmentHeader(deptName); } addTableHead = true; }

    let paramsRows = [];
    const mainRow = [{ content: test.lab_item_test_name, colSpan: 5, styles: { fontStyle:'bold', textColor:[0,0,0], cellPadding:{top:2,bottom:2,left:2} }, isMainTest: true }];
    paramsRows.push(mainRow);
    let hasResultInTable = false;

    for (const param of test.params) {
      const rawName = String(param.test_param_name || "");
      const isStarred = /^\*.+\*$/.test(rawName.trim());
      const pdfName = isStarred ? rawName.trim().replace(/^\*(.+)\*$/, '$1') : rawName;

      if (param.test_param_type === "Editor") {
        if (hasResultInTable) {
          if (paramsRows.length > 1) {
            const est = paramsRows.length * 8 + (addTableHead ? 10 : 0);
            if (!hasSpace(est)) { yPos = await addNewPage(); if (deptName && deptName !== lastPrintedDeptOnCurrentPage) printDepartmentHeader(deptName); addTableHead = true; }
            await autoTable(doc, { startY: yPos, head: addTableHead ? [["TEST NAME","RESULT","UNITS","NORMAL RANGES","METHOD"]] : null, body: paramsRows, theme:'plain', headStyles:{fillColor:[180,220,250],textColor:0,fontStyle:'bold',halign:'center'}, styles:{fontSize:9,cellPadding:2,valign:'middle'}, columnStyles:{0:{cellWidth:48},1:{cellWidth:38,halign:'center'},2:{cellWidth:22,halign:'center'},3:{cellWidth:40,halign:'center'},4:{cellWidth:43,halign:'center'}}, margin:{left:10,right:10}, didDrawCell:(data)=>{ if(data.section==='body'&&data.row.index===0&&data.cell.raw&&data.cell.raw.isMainTest){ doc.setDrawColor(0,0,0); doc.setLineWidth(0.2); const tw=doc.getTextWidth(data.cell.text[0]); const ly=data.cell.y+data.cell.height-1.5; doc.line(data.cell.x+2,ly,data.cell.x+2+tw,ly); } } });
            yPos = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 4 : yPos + 4;
          }
          paramsRows = [mainRow]; hasResultInTable = false; addTableHead = false;
        }
        if (!hasSpace(12)) { yPos = await addNewPage(); if (deptName && deptName !== lastPrintedDeptOnCurrentPage) printDepartmentHeader(deptName); }
        yPos += 4;
        doc.setFontSize(11).setFont('helvetica','bold'); doc.text(pdfName, 16, yPos); yPos += 7;
        const editorContent = String(param.result || '').trim();
        if (editorContent) {
          const tempDiv = document.createElement("div"); tempDiv.innerHTML = editorContent;
          const tableEl = tempDiv.querySelector("table");
          const htmlCont = (() => { if (!tableEl) return tempDiv.innerHTML; const c = tempDiv.cloneNode(true); const t = c.querySelector("table"); if(t)t.remove(); return c.innerHTML; })();
          if (htmlCont && String(htmlCont).trim()) {
            yPos = await drawHtmlContent(doc, htmlCont, 16, yPos, { maxWidth:178, addNewPage: async()=>{ const ny = await addNewPage(); if(deptName&&deptName!==lastPrintedDeptOnCurrentPage)printDepartmentHeader(deptName); return ny; }, pageHeight, pageBuffer:SIGNATURE_AREA_HEIGHT });
            yPos += 4;
          }
          if (tableEl) {
            if (!hasSpace(12)) { yPos = await addNewPage(); if(deptName&&deptName!==lastPrintedDeptOnCurrentPage) printDepartmentHeader(deptName); }
            try {
              autoTable(doc, { startY:yPos, html:tableEl, theme:'grid', styles:{fontSize:9,cellPadding:2,valign:'middle',textColor:[0,0,0],lineColor:[0,0,0],lineWidth:0.2}, headStyles:{textColor:[0,0,0],fillColor:[255,255,255],fontStyle:'bold'}, margin:{left:14,right:14} });
              yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;
            } catch(err) { console.warn("table render failed", err); }
          }
        }
        yPos += 6; continue;
      }

      const hasResult = param.result !== undefined && param.result !== null && String(param.result).trim() !== "";
      if (!hasResult && !isStarred) continue;

      let resultWithFlag = hasResult ? String(param.result).trim() : "";
      let resultStyles = { halign:'center', textColor:[0,0,0] };
      if (hasResult) {
        const rv = formatCellValue(get_param_val(param));
        const match = String(rv).match(/([\d.]+)\s*-\s*([\d.]+)/);
        if (match) {
          const min = parseFloat(match[1]), max = parseFloat(match[2]), val = parseFloat(resultWithFlag);
          if (!isNaN(val)) {
            if (val > max) { resultWithFlag = `${resultWithFlag} H`; resultStyles = {...resultStyles, fontStyle:'bold'}; }
            else if (val < min) { resultWithFlag = `${resultWithFlag} L`; resultStyles = {...resultStyles, fontStyle:'bold'}; }
          }
        }
      }
      paramsRows.push([
        { content: pdfName, styles: isStarred ? { fontStyle:'bold' } : {} },
        { content: resultWithFlag || "", styles: resultStyles },
        param.test_range_type || "",
        formatCellValue(get_param_val(param)) || "",
        param.test_param_method || ""
      ]);
      hasResultInTable = true;
    }

    if (hasResultInTable && paramsRows.length > 1) {
      const est = paramsRows.length * 8 + (addTableHead ? 10 : 0);
      if (!hasSpace(est)) { yPos = await addNewPage(); if(deptName&&deptName!==lastPrintedDeptOnCurrentPage) printDepartmentHeader(deptName); addTableHead = true; }
      await autoTable(doc, { startY:yPos, head: addTableHead ? [["TEST NAME","RESULT","UNITS","NORMAL RANGES","METHOD"]] : null, body:paramsRows, theme:'plain', headStyles:{fillColor:[180,220,250],textColor:0,fontStyle:'bold',halign:'center'}, styles:{fontSize:9,cellPadding:2,valign:'middle'}, columnStyles:{0:{cellWidth:48},1:{cellWidth:38,halign:'center'},2:{cellWidth:22,halign:'center'},3:{cellWidth:40,halign:'center'},4:{cellWidth:43,halign:'center'}}, margin:{left:10,right:10}, didDrawCell:(data)=>{ if(data.section==='body'&&data.row.index===0&&data.cell.raw&&data.cell.raw.isMainTest){ doc.setDrawColor(0,0,0); doc.setLineWidth(0.2); const tw=doc.getTextWidth(data.cell.text[0]); const ly=data.cell.y+data.cell.height-1.5; doc.line(data.cell.x+2,ly,data.cell.x+2+tw,ly); } } });
      yPos = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 4 : yPos + 4;
    }

    // Sample type
    const isRad = (deptName && String(deptName).toLowerCase() === 'radiology') || (test.params[0] && String(test.params[0].test_cat) === '60');
    if (!isRad && test.params[0]?.test_sample_type) {
      if (!hasSpace(15)) { yPos = await addNewPage(); }
      autoTable(doc, { startY:yPos, body:[[{ content:`Sample Type : ${test.params[0].test_sample_type}`, colSpan:5, styles:{fontStyle:'bold',textColor:[80,80,80]} }]], theme:'plain', styles:{fontSize:8,cellPadding:1,valign:'middle'}, margin:{left:14,right:14} });
      yPos = doc.lastAutoTable.finalY + 6;
    } else { yPos += 4; }

    // Interpretation / Impression / Notes
    const drawBordered = async (title, html) => {
      if (!html) return;
      const td = document.createElement('div'); td.innerHTML = String(html).trim();
      const pt = td.innerText.replace(/\u00A0/g,' ').trim();
      if (!pt && !td.querySelector('table')) return;
      const bTop = yPos;
      if (title) { if (!hasSpace(12)) yPos = await addNewPage(); doc.setFontSize(9).setFont('helvetica','bold').text(String(title),16,yPos+5); yPos += 11; }
      else { if (!hasSpace(6)) yPos = await addNewPage(); yPos += 2; }
      yPos = await drawHtmlContent(doc, td.innerHTML, 16, yPos, { maxWidth:178, addNewPage, pageHeight, pageBuffer:SIGNATURE_AREA_HEIGHT });
      yPos += 2;
      const bH = Math.max(10, yPos - bTop);
      try { doc.setDrawColor(0,0,0).setLineWidth(0.2).rect(14, bTop, pageWidth - 28, bH); } catch(e) {}
      yPos += 3;
    };
    await drawBordered('Interpretation', test.interpretation);
    await drawBordered('Impression', test.impression);
    await drawBordered('Notes:', test.notes);
  }

  if (!hasSpace(20)) yPos = await addNewPage();
  doc.setFontSize(12).setFont('helvetica','bold');
  doc.text('*** End of Report ***', pageWidth / 2, yPos + 10, { align:'center' });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    if (hasRadiology) await addLabSignatures(doc, labSignData['60']);
    else await addLabSignatures(doc, labSignData['32']);
    doc.setFontSize(8).setTextColor(0,0,0);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - 14, pageHeight - 18, { align:'right' });
  }

  const pdfBlob = doc.output('blob');
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const newWindow = window.open(pdfUrl, '_blank');
  if (newWindow) { newWindow.onload = () => URL.revokeObjectURL(pdfUrl); }
  else { const a = document.createElement('a'); a.href = pdfUrl; a.download = `report_${patient.lab_reg_id || 'report'}.pdf`; a.click(); URL.revokeObjectURL(pdfUrl); }
};


// ============================================================
// EXISTING OPD FUNCTIONS (kept intact)
// ============================================================

const ExpandedActions = ({ data: row }) => {
  const toLabPrefill = async () => {
    if (!row) return;
    const labPayload = {
      lab_reg_uhid: row.opd_uhid || row.uhid || "",
      lab_reg_id: "",
      lab_reg_name_title: row.opd_patient_title || "Mr.",
      lab_reg_name: row.opd_patient_name || "",
      lab_reg_gender: row.opd_patient_gender || "Male",
      lab_reg_address: row.opd_address || "",
      lab_reg_city: row.opd_city || "",
      lab_reg_state: row.opd_state || "",
      lab_reg_mobile: row.opd_patient_mobile || "",
      lab_reg_age_year: row.opd_guardien_years || row.opd_patient_age || "0",
      lab_reg_age_month: row.opd_guardien_months||"0",
      lab_reg_age_day: "0",
      lab_guardian_title: row.opd_guardien_title || "C/O",
      lab_guardian_name: row.opd_guardien_name || "",
      lab_reg_referral: row.consult_doctor_name || resolveDoctorLabel(row) || "",
      lab_reg_referral_id: row.opd_concult_doctor || row.opd_refer_doctor || "",
      lab_reg_type: "OPD",
      lab_reg_date: (() => { const src = row.opd_datetime || row.opd_reg_date || ""; if(!src) return ""; try { const dt = parseToLocalDate(src); if(!dt||isNaN(dt.getTime())) return String(src); return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,"0")}-${String(dt.getDate()).padStart(2,"0")}`; } catch(e) { return String(src); } })(),
      lab_collected_at: "",
      lab_total: "0", lab_dis_per: "0", lab_fix_deposit: "0", lab_final_amt: "0", lab_paid: "0", lab_due: "0", lab_pay_mode: "Cash",
      lab_remarks: `Referred from OPD - Reg No: ${row.opd_id || ''}`,
      tests1: [], params: [], all_tests: [],
      is_prefilled: true, source_type: "opd", source_id: row.opd_id || "",
    };
    try { sessionStorage.setItem('lab_prefill', JSON.stringify(labPayload)); } catch(e) { toast.error('Failed to prepare lab registration'); return; }
    navigate('/registrations');
  };

  const toEmergencyPrefill = () => {
    if (!row) return;
    const emergencyPayload = { ipd_id:'', ipd_uhid:row.opd_uhid||'', ipd_patient_title:row.opd_patient_title||'Mr.', ipd_patient_name:row.opd_patient_name||'', ipd_patient_gender:row.opd_patient_gender||'Male', ipd_patient_mobile:row.opd_patient_mobile||'', ipd_guardien_title:row.opd_guardien_title||'C/O', ipd_guardien_name:row.opd_guardien_name||'', ipd_address:row.opd_address||'', ipd_city:row.opd_city||'', ipd_age_year:row.opd_guardien_years||row.opd_patient_age||'', ipd_age_month:row.opd_guardien_months||'', ipd_age_day:'', ipd_specality:row.opd_specality||'', ipd_refer_doctor:row.opd_concult_doctor||row.opd_refer_doctor||'', ipd_type:'New Visit', ipd_remarks:`Referred from OPD - Reg No: ${row.opd_id||''}` };
    try { sessionStorage.setItem('emergency_dt', JSON.stringify(emergencyPayload)); } catch(e) { toast.error('Failed'); return; }
    navigate('/emergency_reg');
  };



  const due = parseFloat(row.opd_due || 0);
  return (
    <div style={{ 
      padding:'10px 14px', 
      borderTop:'1px solid #eee', 
      display:'flex', 
      gap:'8px', 
      flexWrap:'wrap', 
      alignItems:'center', 
      backgroundColor:'#f8f9fa' 
    }}>
      {/* Due Badge */}
      {due > 0 && (
        <span className="badge bg-danger fs-6" style={{ padding: '6px 12px' }}>
          Due: ₹{due.toFixed(2)}
        </span>
      )}
      
      {/* Pay Button - Show only if due > 0 */}
      {due > 0 && (
        <button 
          className="btn btn-sm btn-success" 
          onClick={() => handleOpenPayment(row)}
          title="Pay Due Amount">
          <i className="ri-money-rupee-circle-line me-1"></i>
          Pay Now
        </button>
      )}


      
      {/* ✅ Refund Button - Show if paid > 0 */}
      {parseFloat(row.opd_paid || 0) > 0 && (() => {
  const refunded = parseFloat(opdRefundMap[row.opd_id] || 0);
  return (
    <button
      className="btn btn-sm btn-danger"
      onClick={() => handleOpenOpdRefund(row)}
      title={refunded > 0 ? `Already refunded: ₹${refunded.toFixed(2)}` : "Refund Payment"}>
      <i className="ri-refund-2-line me-1"></i>
      Refund
      {refunded > 0 && (
        <span className="badge bg-light text-danger ms-2">
          ₹{refunded.toFixed(2)}
        </span>
      )}
    </button>
  );
})()}





      {/* View Button */}
      <button 
        className="btn btn-sm btn-info" 
        onClick={() => openDetails(row)}
        title="View Details">
        <i className="ri-eye-line me-1"></i>
        View
      </button>
      
      {/* Mark Done Button */}
      <button 
        className="btn btn-sm btn-primary" 
        onClick={() => toggleDone(row)}
        //disabled={Number(row.done || 0) === 1}
        disabled={true}
        title="Mark as Done">
        <i className="ri-check-line me-1"></i>
        {Number(row.done || 0) === 1 ? 'Done' : 'Mark Done'}
      </button>
      
      {/* Add Procedure Bill Button */}
      <button 
        className="btn btn-sm btn-warning" 
        onClick={() => {
          setProcedurePatientData({
            opd_id: row.opd_id,
            ipd_bill_uhid: row.opd_uhid,
            ipd_no: row.opd_id,
            ipd_bill_patient_name: row.opd_patient_name,
            procedure_bill_id: row.procedure_bill_id,
            ...row
          });
          setShowProcedureBill(true);
        }}
        title="Add Procedure Bill">
        <i className="ri-file-list-line me-1"></i>
        {row.procedure_bill_id ? 'Edit Proc Bill' : 'Add Proc Bill'}
      </button>
      
      {/* Add Lab Registration */}
      <button 
        className="btn btn-sm btn-outline-primary" 
        onClick={toLabPrefill} 
        title="Add Lab Registration">
        <i className="ri-flask-line me-1"></i>
        Add Lab
      </button>
      
      {/* Add Emergency/DayCare */}
      <button 
        className="btn btn-sm btn-outline-danger" 
        onClick={toEmergencyPrefill} 
        title="Add Emergency / DayCare Registration">
        <i className="ri-hospital-line me-1"></i>
        Add DayCare / Emergency
      </button>

     
{/* Move to IPD — locked if already moved */}
{row.opd_type === "Move to IPD" ? (
  <button 
    className="btn btn-sm btn-success" 
    disabled
    title="Already moved to IPD"
    style={{ opacity: 0.6, cursor: 'not-allowed' }}>
    <i className="ri-lock-line me-1"></i>
    Moved to IPD
  </button>
) : (
  <button 
    className="btn btn-sm btn-outline-success" 
    onClick={() => moveToIpd(row)}
    title="Move to IPD">
    <i className="ri-hospital-line me-1"></i>
    Move to IPD
  </button>
)}


    </div>
  );
};


function parseToLocalDate(dtStr) {
  if (!dtStr) return null; const s = String(dtStr).trim();
  if (s instanceof Date) return s;
  if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(s)) { const d = new Date(s); return isNaN(d.getTime()) ? null : d; }
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):?(\d{2})?)?$/);
  if (m) { const d = new Date(parseInt(m[1]),parseInt(m[2])-1,parseInt(m[3]),m[4]?parseInt(m[4]):0,m[5]?parseInt(m[5]):0,m[6]?parseInt(m[6]):0); return isNaN(d.getTime())?null:d; }
  const d = new Date(s); return isNaN(d.getTime()) ? null : d;
}

function formatDateTime(dtStr) {
  if (!dtStr) return "";
  try {
    let d = new Date(dtStr); if (isNaN(d.getTime())) { d = new Date(String(dtStr).trim().replace(" ","T")); }
    if (isNaN(d.getTime())) return String(dtStr);
    const dd = String(d.getDate()).padStart(2,"0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    let hh = d.getHours(); const ampm = hh >= 12 ? "PM" : "AM"; hh = hh % 12; if (hh === 0) hh = 12;
    return `${dd}-${months[d.getMonth()]}-${d.getFullYear()} ${String(hh).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")} ${ampm}`;
  } catch(e) { return String(dtStr); }
}

function resolveDoctorLabel(row) {
  if (!row) return 'N/A';
  const explicit = row.opd_concult_doctor_name || row.consult_doctor_name || row.opd_refer_doctor_name || row.doctor_name;
  if (explicit && String(explicit).trim() !== '') return String(explicit).trim();
  const id = (row.opd_concult_doctor ?? row.opd_refer_doctor ?? row.doctor_id ?? '').toString();
  if (id && doctorsMap && doctorsMap[id]) return doctorsMap[id];
  if (Array.isArray(formData.doc)) {
    const c = formData.doc.find(d => { if(!d) return false; return [d.user_id,d.id,d.userId,d.doctor_id,d.doc?.doc_parent,d.doc?.doc_user,d.doc?.doc_id].map(x=>x==null?'':String(x).trim().toLowerCase()).includes(id.trim().toLowerCase()); });
    if (c) return (c.fname||c.name||c.full_name||c.doc?.doc_name||id).toString();
  }
  return id || 'N/A';
}

function getDoctorNameById(id, fallbackName) {
  if (id === undefined || id === null || id === '') return fallbackName || 'N/A';
  const strId = String(id).trim();
  const docs = Array.isArray(formData.doc) ? formData.doc : [];
  const d = docs.find(d => d && [d.user_id,d.id,d.doc?.doc_parent,d.doc?.doc_id,d.doc?.doc_user].filter(Boolean).some(c => String(c).trim() === strId));
  if (d) { const name = (d.fname||d.name||d.full_name||'').trim(); const extra = [d.doc?.doc_degree,d.doc?.doc_specality].filter(Boolean).join(' / '); return extra ? `${name} (${extra})` : (name||'Doctor'); }
  return fallbackName || `Doctor (${strId})`;
}

const getLoggedRoleId = () => { try { const raw = sessionStorage.getItem('ldata')||localStorage.getItem('ldata'); if(!raw)return null; const p = JSON.parse(raw); return p?.role_id??p?.roleId??null; } catch(e){return null;} };
const isEditableRecord = (record) => { if(!record) return false; if(record.opd_type==="Move to IPD") return false; if(String(getLoggedRoleId()??'')==='1') return true; if(!record.opd_datetime) return true; const rd=new Date(record.opd_datetime); if(isNaN(rd.getTime())) return false; return (new Date()-rd)<(24*60*60*1000); };

const loggedUser = useMemo(() => { try { return JSON.parse(sessionStorage.getItem("ldata")||"{}"); } catch{return {};} }, []);
const isDoctorLogin = loggedUser?.type === 'doctor';
const loggedDoctorId = loggedUser?.user_id ? String(loggedUser.user_id) : '';

const [ldata, setLdata] = useState(null);

const doctorOptions = useMemo(() => {
  const map = new Map();
  if (Array.isArray(formData.doc)) { formData.doc.forEach((d,i) => { try { const id = d?.user_id??d?.id??`doc_${i}`; const label = (d?.fname||d?.name||d?.full_name||String(id)).toString().trim(); if(id!=null&&label) map.set(String(id),label); } catch(e){} }); }
  if (Array.isArray(formData.l1)) { formData.l1.forEach((r,i) => { try { let id = [r.opd_concult_doctor,r.opd_refer_doctor,r.doctor_id].find(x=>x!=null&&String(x).trim()!==""); const label = (r.consult_doctor_name||r.opd_concult_doctor_name||r.doctor_name||(id?String(id):`Doc ${i+1}`)).toString().trim(); const key = id!=null?String(id).trim():`opd_doc_${i}`; if(key&&label) map.set(key,label); } catch(e){} }); }
  return Array.from(map.entries()).map(([value,label])=>({value,label})).sort((a,b)=>a.label.localeCompare(b.label));
}, [formData.doc, formData.l1]);

const openDetails = (row) => {
  if (!row) return;
  
  const booking = appointmentMap[String(row.opd_id || '')];
  const ageStr = [
      row.opd_guardien_years  ? `${row.opd_guardien_years}Y`  : '',
      row.opd_guardien_months ? `${row.opd_guardien_months}M` : '',
      row.opd_guardien_days   ? `${row.opd_guardien_days}D`   : '',
  ].filter(Boolean).join(' ') || row.opd_guardien_age || 'N/A';

  const due = parseFloat(row.opd_due || 0);
  const dueColor = due > 0 ? '#dc3545' : '#198754';

  Swal.fire({
      title: `<span style="font-size:16px">${row.opd_patient_title || ''} ${row.opd_patient_name || 'Patient'}</span>`,
      html: `
          <table style="width:100%;text-align:left;font-size:13px;border-collapse:collapse;">
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666;width:45%"><b>UHID</b></td>
                  <td style="padding:6px 8px">${row.opd_uhid || 'N/A'}</td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Phone No</b></td>
                  <td style="padding:6px 8px">
                      ${row.opd_patient_mobile
                          ? `<a href="tel:${row.opd_patient_mobile}">${row.opd_patient_mobile}</a>`
                          : 'N/A'}
                  </td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Age / Gender</b></td>
                  <td style="padding:6px 8px">${ageStr} / ${row.opd_patient_gender || 'N/A'}</td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Guardian</b></td>
                  <td style="padding:6px 8px">
                      ${row.opd_guardien_title || ''} ${row.opd_guardien_name || 'N/A'}
                  </td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Doctor</b></td>
                  <td style="padding:6px 8px">${resolveDoctorLabel(row)}</td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Status</b></td>
                  <td style="padding:6px 8px">
                      <span style="background:#e7f0ff;color:#405189;padding:2px 8px;border-radius:4px;font-size:12px">
                          ${row.opd_type || 'N/A'}
                      </span>
                  </td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Final Amount</b></td>
                  <td style="padding:6px 8px">₹${parseFloat(row.opd_final_amt || 0).toFixed(2)}</td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Paid</b></td>
                  <td style="padding:6px 8px">₹${parseFloat(row.opd_paid || 0).toFixed(2)}</td>
              </tr>
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Due</b></td>
                  <td style="padding:6px 8px;font-weight:bold;color:${dueColor}">
                      ₹${due.toFixed(2)}
                      ${due > 0 ? '<span style="margin-left:6px;font-size:11px;background:#dc3545;color:#fff;padding:1px 6px;border-radius:10px">Pending</span>' : '<span style="margin-left:6px;font-size:11px;background:#198754;color:#fff;padding:1px 6px;border-radius:10px">Cleared</span>'}
                  </td>
              </tr>
              ${booking ? `
              <tr style="border-bottom:1px solid #eee">
                  <td style="padding:6px 8px;color:#666"><b>Appointment</b></td>
                  <td style="padding:6px 8px">
                      <span style="background:#0d6efd;color:#fff;padding:2px 8px;border-radius:4px;font-size:12px">
                          ${booking.time_display || booking.booking_time} — ${booking.booking_date}
                      </span>
                  </td>
              </tr>` : ''}
              <tr>
                  <td style="padding:6px 8px;color:#666"><b>Address</b></td>
                  <td style="padding:6px 8px">${row.opd_address || 'N/A'}</td>
              </tr>
          </table>
      `,
      width: 520,
      showCloseButton: true,
      confirmButtonText: 'Close',
      confirmButtonColor: '#405189'
  });
};

const initData2 = async () => {
  try {
    const fd = new FormData(); fd.append('type','doctor'); fd.append('page_no','none'); fd.append('user_cre_by','all');
    const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, { headers:{'Content-Type':'multipart/form-data'} });
    if (response?.data?.status && Array.isArray(response.data.records)) {
      const doctors = response.data.records;
      setFormData(prev => { if(isDoctorLogin&&loggedDoctorId&&!prev.selectedDoctorId) return {...prev,doc:doctors,selectedDoctorId:loggedDoctorId}; return {...prev,doc:doctors}; });
    }
  } catch(err) { console.error("initData2 error",err); }
};

const toggleDone = async (row) => {
  if(!row||!row.opd_id) return; if(Number(row.done)===1){toast.info("Already marked done.");return;}
  setFormData(prev=>({...prev,l1:(prev.l1||[]).map(r=>(r.opd_id===row.opd_id?{...r,done:1}:r))}));
  try { const fd=new FormData(); fd.append('opd_id',row.opd_id+""); fd.append('done','1'); const resp=await axios.post(AppConst.BASE_URL+AppConst.updateOpdDoneUrl,fd,{headers:{'Content-Type':'multipart/form-data'}}); if(resp?.data?.status){toast.success(resp.data.success||'Marked done');} else{setFormData(prev=>({...prev,l1:(prev.l1||[]).map(r=>(r.opd_id===row.opd_id?{...r,done:row.done??0}:r))}));toast.error(resp?.data?.error||'Failed');} } catch(err){setFormData(prev=>({...prev,l1:(prev.l1||[]).map(r=>(r.opd_id===row.opd_id?{...r,done:row.done??0}:r))}));toast.error("Network error");}
};

const lastResponseRef = useRef({ page:null, recordsHash:null });
const initData = async (opts = {}) => {
  const p = opts.page ?? pageNo; const size = opts.size ?? pageSize;
  const fromDate = opts.from ?? formData.from;   // ✅ ADD
  const toDate = opts.to ?? formData.to;         // ✅ ADD
  const sendRequest = async (useOneBased = false) => {
    const fd = new FormData(); const serverPage = useOneBased ? (p+1) : p;
    fd.append('page_no',String(serverPage)); fd.append('page_size',String(size));
    const searchKey = (formData.search_key||"").toString().trim();
    
    if (searchKey !== "") {
      fd.append('search_key', searchKey);
      fd.append('from', "");
      fd.append('to', "");
    } else {
      fd.append('search_key', "");
      if (fromDate) fd.append('from', fromDate);     // ✅ USE override
      if (toDate) fd.append('to', toDate);           // ✅ USE override
    }
    try{
      const response=await axios.post(AppConst.BASE_URL+AppConst.getOpdListUrl,fd,{headers:{'Content-Type':'multipart/form-data'}});
      if(response?.data&&response.data.status){
        const records=response.data.records||[]; const hash=records.map(r=>r.opd_id).join('|');
        const last=lastResponseRef.current;
        if(!useOneBased&&last.recordsHash&&last.recordsHash===hash&&p>0) return await sendRequest(true);
        setFormData(prev=>({...prev,l1:records}));
        if (response.data.refund_map) {
          setOpdRefundMap(response.data.refund_map);
        }
        if(typeof response.data.total!=='undefined') setTotalCount(Number(response.data.total)||0);
        if(typeof response.data.page_size!=='undefined') setPageSize(Number(response.data.page_size)||size);
        lastResponseRef.current={page:serverPage,recordsHash:hash}; setPageNo(p);
        return{success:true};
      } else{setFormData(prev=>({...prev,l1:[]}));setTotalCount(0);return{success:false};}
    }catch(err){console.error("Error fetching OPD list",err);setFormData(prev=>({...prev,l1:[]}));setTotalCount(0);return{success:false};}
  };
  await sendRequest(false);
};

const handleChange = (e) => { const{name,value}=e.target; setFormData(prev=>({...prev,[name]:value})); };
const delItem = async (editItem) => { if(!window.confirm("Are you sure want to delete this record?"))return; const fd=new FormData(); fd.append('opd_id',editItem.opd_id+"");  attachUserInfo(fd); try{const response=await axios.post(AppConst.BASE_URL+AppConst.deleteOpdUrl,fd,{headers:{'Content-Type':'multipart/form-data'}}); if(response.data.status){await initData();toast.success("deleted successfully");}} catch(err){toast.error("Delete Error : "+err);} };

//const updateOpdType = async (item) => { const fd=new FormData(); fd.append('opd_id',item.opd_id); fd.append('opd_patient_name',item.opd_patient_name??''); fd.append('opd_type','Move to IPD'); fd.append('opd_uhid',item.opd_uhid??''); fd.append('opd_datetime',item.opd_datetime??new Date().toISOString()); fd.append('opd_items',JSON.stringify([])); fd.append('opd_comps',JSON.stringify([])); try{await axios.post(AppConst.BASE_URL+AppConst.addOpdUrl,fd,{headers:{'Content-Type':'multipart/form-data'}});}catch(err){} };


const updateOpdType = async (item) => { 
  const fd = new FormData(); 
  fd.append('opd_id', item.opd_id); 
  fd.append('opd_patient_name', item.opd_patient_name ?? ''); 
  fd.append('opd_patient_title', item.opd_patient_title ?? '');
  fd.append('opd_type', 'Move to IPD'); 
  fd.append('opd_uhid', item.opd_uhid ?? ''); 
  fd.append('opd_concult_doctor', item.opd_concult_doctor ?? '');
  fd.append('opd_specality', item.opd_specality ?? '');
  fd.append('opd_patient_mobile', item.opd_patient_mobile ?? '');
  fd.append('opd_patient_gender', item.opd_patient_gender ?? '');
  fd.append('opd_guardien_title', item.opd_guardien_title ?? '');
  fd.append('opd_guardien_name', item.opd_guardien_name ?? '');
  fd.append('opd_guardien_age', item.opd_guardien_age ?? '');
  fd.append('opd_guardien_years', item.opd_guardien_years ?? '0');
  fd.append('opd_guardien_months', item.opd_guardien_months ?? '0');
  fd.append('opd_guardien_days', item.opd_guardien_days ?? '0');
  fd.append('opd_address', item.opd_address ?? '');
  fd.append('opd_city', item.opd_city ?? '');
  fd.append('opd_datetime', item.opd_datetime ?? new Date().toISOString()); 
  fd.append('opd_items', JSON.stringify([])); 
  fd.append('opd_comps', JSON.stringify([])); 
  try {
    await axios.post(AppConst.BASE_URL + AppConst.addOpdUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  } catch(err) {
    console.error("updateOpdType error:", err);
  } 
};

const moveToIpd = async (item) => { 
  if(!item) return; 
  const c = await Swal.fire({
    title:`Move ${item.opd_patient_name||''} to IPD?`,
    icon:"warning",
    showCancelButton:true,
    confirmButtonText:"Yes, Move"
  }); 
  if(!c.isConfirmed) return; 
  
  const fd = new FormData(); 
  fd.append('opd_id', item.opd_id); 
  fd.append('ipd_uhid', item.opd_uhid ?? ''); 
  fd.append('ipd_patient_title', item.opd_patient_title ?? '');
  fd.append('ipd_patient_name', item.opd_patient_name ?? ''); 
  fd.append('ipd_patient_gender', item.opd_patient_gender ?? ''); 
  fd.append('ipd_patient_mobile', item.opd_patient_mobile ?? '');
  fd.append('ipd_guardien_title', item.opd_guardien_title ?? '');
  fd.append('ipd_guardien_name', item.opd_guardien_name ?? '');
  fd.append('ipd_guardien_age', item.opd_guardien_age ?? '');
  fd.append('ipd_age_year', item.opd_guardien_years ?? '0');
  fd.append('ipd_age_month', item.opd_guardien_months ?? '0');
  fd.append('ipd_age_day', item.opd_guardien_days ?? '0');
  fd.append('ipd_address', item.opd_address ?? '');
  fd.append('ipd_city', item.opd_city ?? '');
  fd.append('ipd_specality', item.opd_specality ?? '');
  fd.append('ipd_type', 'OPD'); 
  fd.append('ipd_remarks', 'Moved from OPD'); 
  fd.append('ipd_refer_doctor', item.opd_concult_doctor ?? '');
  
  try {
    const ldataL = JSON.parse(localStorage.getItem("data") || "{}"); 
    if(ldataL?.user_id) fd.append('ipd_user', ldataL.user_id);
  } catch(e) {} 
  
  try {
    Swal.fire({title:'Moving...',allowOutsideClick:false,didOpen:()=>Swal.showLoading()}); 
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.addIpdUrl, fd,
      {headers:{'Content-Type':'multipart/form-data'}}
    ); 
    Swal.close(); 
    if(response?.data?.status) {
      await updateOpdType(item);
      await initData();
      await Swal.fire({title:'Moved!',icon:'success'});
      window.location.reload();
    } else {
      Swal.fire({title:'Failed',icon:'error'});
    }
  } catch(err) {
    Swal.close();
    Swal.fire({title:'Error',icon:'error'});
  } 
};

const fetchConfigData = async () => { try{const res=await axios.post(`${AppConst.BASE_URL+AppConst.getconfig}?config_type=lab`);if(res.data.status){setHeaderLogo(res.data.header_logo);setWatermarkLogo(res.data.logo||'');setFooterImage(res.data.footer_logo);}}catch(err){} };

const handlePrint = (record, doctors) => {
  const selectedDoctor = doctors.find(doc => doc.user_id === record.opd_concult_doctor);
  const doctorDescription = selectedDoctor ? `${selectedDoctor.fname} / ${selectedDoctor.doc?.doc_degree || ''} / ${selectedDoctor.doc?.doc_specality || ''}` : 'Doctor Details Not Found';
  const token = record.opd_token_no; const timeStamp = Date.now();
  const invoiceData = { config:{headerLogoUrl:headerLogo}, patient:{uhid:record.opd_uhid||'N/A',name:`${record.opd_patient_title||''} ${record.opd_patient_name}`,ageSex:`${record.opd_guardien_age||'30'}Y / ${record.opd_patient_gender}`,address:record.opd_address||'N/A'}, payment:{method:record.opd_mode}, bill:{date:record.opd_datetime,no:`${timeStamp}-${token}`,token,receiptNo:`${record.opd_patient_name||'N/A'}-${token}`,visitDate:record.opd_datetime}, transactions:[{sno:1,description:doctorDescription,amount:parseFloat(record.opd_fees||0)}], summary:{regCharges:parseFloat(record.opd_reg_fees||0),billAmount:parseFloat(record.opd_total||0),discount:parseFloat(record.opd_discount||0),paid:parseFloat(record.opd_paid||0),due:parseFloat(record.opd_due||0),totalInWords:''} };
  // simplified invoice generation
  toast.info("Invoice generation triggered");
};

const handlePrintPrescription = (record, doctors) => { toast.info("Prescription print triggered"); };

const confirmEdit = async (row) => { if(!row) return; if(row.opd_type==="Move to IPD"){await Swal.fire({icon:'error',title:'Cannot Edit'});return;} if(!isEditableRecord(row)){await Swal.fire({icon:'info',title:'Edit Locked'});return;} const r=await Swal.fire({title:'Edit?',icon:'question',showCancelButton:true,confirmButtonText:'Yes, Edit'}); if(r.isConfirmed){try{sessionStorage.setItem("opd_dt",JSON.stringify(row));}catch(e){} window.location.href="/opd_registrations";} };
const confirmDelete = async (row) => { if(!row) return; if(row.opd_type==="Move to IPD"){await Swal.fire({icon:'error',title:'Cannot Delete'});return;} const r=await Swal.fire({title:'Sure?',icon:'warning',showCancelButton:true,confirmButtonText:'Yes, delete',confirmButtonColor:'#d33'}); if(r.isConfirmed){try{await delItem(row);}catch(err){Swal.fire({icon:'error',title:'Delete Failed'});}} };
function resolveUserDisplay(row) { if(!row)return''; const preNames=[row.user_display,row.last_used,row.last_used_name,row.opd_user_name,row.user_name,row.fname]; for(const p of preNames){if(p!=null&&String(p).trim()!=='') return String(p).trim();} return''; }

// ============================================================
// EFFECTS
// ============================================================
useEffect(() => { if(formData.search_key==='') return; const t=setTimeout(()=>{initData({page:0,size:pageSize});},500); return()=>clearTimeout(t); }, [formData.search_key]);
useEffect(() => { if(showProcedureBill){setOpenDropdownId(null);document.body.classList.add('modal-open');}else{document.body.classList.remove('modal-open');} return()=>{document.body.classList.remove('modal-open');}; }, [showProcedureBill]);
// Replace your existing loadAll useEffect:
useEffect(() => {
  const loadAll = async () => {
      const s = sessionStorage.getItem("ldata");
      if (s) setLdata(JSON.parse(s));
      await initData2();
      await initData();
      await fetchLabConfig();
      await fetchAppointmentsForDate(todayDate, todayDate);
  };
  loadAll();
}, []);
// Add this CSS once in OPD component
useEffect(() => {
  const css = `
    .swal2-container.swal2-on-top-of-modal {
      z-index: 99999 !important;
    }
  `;
  const style = document.createElement('style');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
  return () => { document.head.removeChild(style); };
}, []);
useEffect(() => {
  if (formData.from) {
      fetchAppointmentsForDate(formData.from, formData.to);
  }
}, [formData.from, formData.to]);

// ✅ Fetch lab data whenever OPD list changes
useEffect(() => { if(formData.l1 && formData.l1.length > 0) fetchLabDataForOpdPatients(); }, [formData.l1.length, formData.from, formData.to]);

useEffect(() => { const h=(e)=>{if(openDropdownId===null)return;const el=document.getElementById(`dropup-${openDropdownId}`);if(el&&!el.contains(e.target))setOpenDropdownId(null);}; const k=(e)=>{if(e.key==="Escape")setOpenDropdownId(null);}; document.addEventListener("pointerdown",h);document.addEventListener("keydown",k);return()=>{document.removeEventListener("pointerdown",h);document.removeEventListener("keydown",k);}; }, [openDropdownId]);

const displayedRows = useMemo(() => {
  let list = formData.l1 || [];
  const sKey = (formData.search_key || '').trim().toLowerCase();

  if (sKey !== "") {
    list = list.filter(item =>
      (`${item.opd_uhid || ''}${item.opd_id || ''}${item.opd_patient_mobile || ''}${item.opd_patient_name || ''}${item.opd_guardien_name || ''}${item.opd_address || ''}`)
        .toLowerCase().includes(sKey)
    );
  } else {
    const fromRaw = formData.from ? String(formData.from).trim() : "";
    const toRaw = formData.to ? String(formData.to).trim() : "";
    let fromStart = null, toEnd = null;
    if (fromRaw) { const p = parseToLocalDate(fromRaw); if (p) fromStart = new Date(p.getFullYear(), p.getMonth(), p.getDate(), 0, 0, 0, 0).getTime(); }
    if (toRaw) { const p = parseToLocalDate(toRaw); if (p) toEnd = new Date(p.getFullYear(), p.getMonth(), p.getDate(), 23, 59, 59, 999).getTime(); }

    if (fromStart !== null || toEnd !== null) {
      list = list.filter(item => {
        // ✅ KEY CHANGE: Use appointment date if booked, else use registration date
        const booking = appointmentMap[String(item.opd_id || '')];
        let effectiveDate = null;

        if (booking && booking.booking_date) {
          // Appointment exists → use appointment date for filtering
          effectiveDate = parseToLocalDate(booking.booking_date);
        } else if (item.opd_datetime) {
          // No appointment → use registration date
          effectiveDate = parseToLocalDate(item.opd_datetime);
        }

        if (!effectiveDate) return true;
        const rt = effectiveDate.getTime();
        if (fromStart !== null && rt < fromStart) return false;
        if (toEnd !== null && rt > toEnd) return false;
        return true;
      });
    }
  }

  const selDoc = (formData.selectedDoctorId || "").toString().trim();
  if (selDoc !== "") {
    list = list.filter(item => {
      const ids = [item.opd_concult_doctor, item.opd_refer_doctor, item.doctor_id].map(x => x == null ? "" : String(x).trim());
      const names = [item.consult_doctor_name, item.opd_concult_doctor_name, item.doctor_name].map(x => x == null ? "" : String(x).trim().toLowerCase());
      return ids.some(id => id === selDoc) || names.some(n => n === selDoc.toLowerCase() || n.includes(selDoc.toLowerCase()));
    });
  }

  // ✅ SORT: Patients with appointments sorted by appointment date+time first, then by reg date
  list = [...list].sort((a, b) => {
    const bookingA = appointmentMap[String(a.opd_id || '')];
    const bookingB = appointmentMap[String(b.opd_id || '')];

    // Helper to get a sortable timestamp
    const getSortKey = (row, booking) => {
      if (booking && booking.booking_date) {
        // Combine booking_date + booking_time (HH:MM:SS or HH:MM)
        const dateStr = booking.booking_date;
        const timeStr = booking.booking_time || '00:00:00';
        const combined = `${dateStr}T${timeStr.length === 5 ? timeStr + ':00' : timeStr}`;
        const d = new Date(combined);
        if (!isNaN(d.getTime())) return d.getTime();
      }
      // Fallback to registration datetime
      const d = parseToLocalDate(row.opd_datetime);
      return d ? d.getTime() : 0;
    };

    return getSortKey(a, bookingA) - getSortKey(b, bookingB);
  });

  return list;
}, [formData.l1, formData.search_key, formData.from, formData.to, formData.selectedDoctorId, doctorsMap, appointmentMap]);
useEffect(() => {
  let totalAmount=0,discountAmount=0,paidAmount=0,dueAmount=0,totalCharges=0,procBillAmount=0,procBillCash=0,procBillCard=0,procBillOnline=0;
  displayedRows.forEach(item=>{totalAmount+=parseFloat(item.opd_final_amt||0);discountAmount+=parseFloat(item.opd_discount||0);paidAmount+=parseFloat(item.opd_paid||0);dueAmount+=parseFloat(item.opd_due||0);totalCharges+=parseFloat(item.opd_reg_fees||0);procBillAmount+=parseFloat(item.procedure_bill_amount||0);procBillCash+=parseFloat(item.procedure_bill_cash||0);procBillCard+=parseFloat(item.procedure_bill_card||0);procBillOnline+=parseFloat(item.procedure_bill_online||0);});
  totalAmount+=procBillAmount;
  setTotals({totalAmount,discountAmount,paidAmount,dueAmount,totalCharges,procBillAmount,procBillCash,procBillCard,procBillOnline});
}, [displayedRows]);






const handleOpenPayment = (patient) => {
  const due = parseFloat(patient.opd_due || 0);
  if (due <= 0) {
    toast.info('No due amount for this patient');
    return;
  }
  
  setPaymentPatient(patient);
  setPaymentAmount(due.toFixed(2)); // Pre-fill with full due amount
  setPaymentMode('Cash');
  setShowPaymentModal(true);
};
 
// Process payment
const handleProcessPayment = async () => {
  const amt = parseFloat(paymentAmount || 0);
  const due = parseFloat(paymentPatient?.opd_due || 0);
 
  if (amt <= 0) {
    toast.error('Enter a valid payment amount');
    return;
  }
 
  if (amt > due) {
    toast.error(`Payment amount cannot exceed due amount (₹${due.toFixed(2)})`);
    return;
  }
 
  if (!paymentMode) {
    toast.error('Select payment mode');
    return;
  }
 
  setPaymentProcessing(true);
 
  try {
    const fd = new FormData();
    fd.append('opd_id', paymentPatient.opd_id);
    fd.append('payment_amount', amt);
    fd.append('payment_mode', paymentMode);
    fd.append('payment_date', new Date().toISOString().split('T')[0]);
    fd.append('payment_time', new Date().toTimeString().split(' ')[0]);
    
    // Get user_id from session/localStorage
    const ldataStr = sessionStorage.getItem('ldata') || localStorage.getItem('ldata');
    const ldata = ldataStr ? JSON.parse(ldataStr) : {};
    fd.append('user_id', ldata.user_id || '1');
 
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.opdPaymentUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
 
    if (res.data?.status) {
      toast.success(res.data.message || 'Payment recorded successfully');
 
      // Update local state immediately
      setFormData(prev => ({
        ...prev,
        l1: prev.l1.map(p => 
          p.opd_id === paymentPatient.opd_id
            ? { ...p, opd_paid: res.data.new_paid, opd_due: res.data.new_due }
            : p
        )
      }));
 
      setShowPaymentModal(false);
      setPaymentPatient(null);
      setPaymentAmount('');
      
      // Refresh the list
      setTimeout(() => initData(), 500);
    } else {
      toast.error(res.data?.message || 'Payment failed');
    }
  } catch (err) {
    console.error('Payment error:', err);
    toast.error('Error processing payment');
  } finally {
    setPaymentProcessing(false);
  }
};


// ============================================================
// COLUMNS
// ============================================================
const columns = [
  { name:'Action', cell:row=>{ const editable=isEditableRecord(row); const userIsAdmin=String(getLoggedRoleId()??'')==='1'; return(<><button type="button" onClick={async(e)=>{e.preventDefault();e.stopPropagation();await confirmEdit(row);}} className="btn btn-sm btn-outline-warning" style={{opacity:editable?1:0.5}} disabled={!editable}><i className="ri-pencil-fill"></i></button>&nbsp;&nbsp;<button type="button" onClick={async(e)=>{e.preventDefault();e.stopPropagation();if(!userIsAdmin){toast.error("Only admin can delete.");return;} await confirmDelete(row);}} className="btn btn-sm btn-outline-danger" style={{opacity:userIsAdmin?1:0.5}} disabled={!userIsAdmin}><i className="ri-delete-bin-5-fill fs-16"></i></button></>); }, ignoreRowClick:true, allowOverflow:true, button:true, width:'140px' },
  //{ name:'', width:'230px', cell:row=>{ const hasPB=row.procedure_bill_id||row.has_procedure_bill; return(<><button className="btn btn-sm btn-primary me-2" onClick={(e)=>{e.stopPropagation();openDetails(row);}}>View</button><button className={`btn btn-sm ${hasPB?'btn-warning':'btn-success'}`} onClick={(e)=>{e.stopPropagation();setOpenDropdownId(null);setTimeout(()=>{setProcedurePatientData({opd_id:row.opd_id,ipd_bill_uhid:row.opd_uhid,ipd_no:row.opd_id,ipd_bill_patient_name:row.opd_patient_name,procedure_bill_id:row.procedure_bill_id,...row});setShowProcedureBill(true);},10);}}>{hasPB?'Edit Proc Bill':'Add Proc Bill'}</button></>); }, ignoreRowClick:true, allowOverflow:true, button:true },
  //{ name:'Done', width:'90px', cell:row=>{const isDone=Number(row.done||0)===1;return(<button className={`btn btn-sm ${isDone?'btn-success':'btn-outline-primary'}`} onClick={(e)=>{e.stopPropagation();if(!isDone)toggleDone(row);}} disabled={isDone}>{isDone?'Done':'Mark Done'}</button>);}, ignoreRowClick:true, allowOverflow:true, button:true },
   // ============================================================
  // ✅ LAB REPORT COLUMN
  // ============================================================




  {
    name: 'Appointment',
    width: '140px',
    center: true,
    cell: row => {
        const booking = appointmentMap[String(row.opd_id || '')];
        if (!booking) return <span className="text-muted" style={{fontSize:12}}>—</span>;
        return (
            <div style={{textAlign:'center'}}>
                <span className="badge bg-primary px-2 py-1" style={{fontSize:'11px', display:'block'}}>
                    {booking.time_display || booking.booking_time}
                </span>
                <small style={{fontSize:10, color:'#555'}}>
                    {booking.booking_date}
                </small>
            </div>
        );
    }
},

  {
    name: 'Lab Report',
    width: '150px',
    center: true,
    cell: row => {
      const labRegs = getLabRegsForOpdRow(row);

      if (labRegs.length === 0) {
        return <span className="badge bg-light text-muted" style={{ fontSize:'0.8rem' }}>No Lab</span>;
      }

      // Use the latest (most recent) registration for status display
      const latest = labRegs[0];
      const status = (latest.lab_reg_status || '').toString().trim().toLowerCase();
      const labDue = Number(latest.lab_due || 0);
      const count = labRegs.length;

      return (
        <div style={{ textAlign:'center' }}>
          {/* Pending */}
          {status === "pending" && (
            <div>
              <i className="ri-flask-fill" style={{ color:"red", fontSize:"22px" }} title="Sample Pending"></i>
              <div style={{ fontSize:'0.7rem', color:'#dc3545' }}>Pending</div>
            </div>
          )}

          {/* Sample Collected */}
          {status === "sample collected" && (
            <div>
              <i className="ri-drop-fill" style={{ color:"#fd7e14", fontSize:"22px" }} title="Sample Collected"></i>
              <div style={{ fontSize:'0.7rem', color:'#fd7e14' }}>Collected</div>
            </div>
          )}

          {/* Completed + No Due → Green print */}
          {status === "completed" && labDue === 0 && (
            <div>
              <i
                className="ri-printer-fill"
                style={{ color:"green", fontSize:"22px", cursor:"pointer" }}
                title={count > 1 ? `${count} Lab Registrations — Click to select` : "Print Lab Report"}
                onClick={(e) => { e.stopPropagation(); handleLabReportClick(row); }}
              />
              <div style={{ fontSize:'0.7rem', color:'#198754' }}>
                Ready {count > 1 && <span className="badge bg-info" style={{fontSize:'0.65rem',marginLeft:2}}>{count}</span>}
              </div>
            </div>
          )}

          {/* Completed + Due > 0 → Blue print with warning */}
          {status === "completed" && labDue > 0 && (
            <div>
              <i
                className="ri-printer-fill"
                style={{ color:"blue", fontSize:"22px", cursor:"pointer" }}
                title={`Due: ₹${labDue.toFixed(2)}`}
                onClick={(e) => {
                  e.stopPropagation();
                  Swal.fire({ icon:"warning", title:"Lab Payment Due", text:`₹${labDue.toFixed(2)} due in lab.`, confirmButtonText:"OK" });
                }}
              />
              <div style={{ fontSize:'0.7rem', color:'#0d6efd' }}>Due: ₹{labDue.toFixed(0)}</div>
            </div>
          )}

          {/* Other status */}
          {status !== "pending" && status !== "sample collected" && status !== "completed" && (
            <span className="badge bg-secondary" style={{ fontSize:'0.75rem' }}>{latest.lab_reg_status||'Unknown'}</span>
          )}
        </div>
      );
    }
  },
  //{ name:'Status', selector:row=>row.opd_type, cell:row=><span className="badge bg-primary-subtle text-primary fs-6">{row.opd_type}</span> },
  { name:'Status', selector:row=>row.opd_type, cell:row=>{
    const isMovedToIPD = row.opd_type === "Move to IPD";
    return isMovedToIPD
      ? <span className="badge fs-6" style={{ backgroundColor:'#198754', color:'#fff', padding:'6px 10px' }}>
          <i className="ri-hospital-line me-1"></i>Moved to IPD
        </span>
      : <span className="badge bg-primary-subtle text-primary fs-6">{row.opd_type}</span>;
  }},
  
  { name:'', width:'48px', cell:row=>(<div id={`dropup-${row.opd_id}`} className="dropup"><button className="btn btn-link text-muted p-0" onClick={(e)=>{e.stopPropagation();setOpenDropdownId(prev=>(prev===row.opd_id?null:row.opd_id));}}><i className="ri-more-2-fill fs-18"></i></button><ul className={`dropdown-menu dropdown-menu-end shadow ${openDropdownId===row.opd_id?'show':''}`} style={{display:openDropdownId===row.opd_id?'block':'none',position:'relative'}}><li><button className="dropdown-item" onClick={()=>handlePrintPrescription(row,formData.doc)}>Print Prescriptions</button></li><li><button className="dropdown-item" onClick={()=>handlePrint(row,formData.doc)}>Print Invoice</button></li>
  <li>
  <button 
    className="dropdown-item" 
    onClick={()=>moveToIpd(row)} 
    disabled={row.opd_type==="Move to IPD"}
    style={row.opd_type==="Move to IPD" ? {opacity:0.5, cursor:'not-allowed'} : {}}>
    {row.opd_type==="Move to IPD" ? '✅ Already Moved to IPD' : 'Move to IPD'}
  </button>
</li></ul></div>) },
  { name:'Sn.', cell:(row,rowIndex)=><div>{(Number(pageNo)||0)*(Number(pageSize)||15)+(rowIndex+1)}</div>, width:'60px', sortable:false },
  
  { name:'Patient Name', selector:row=>`${row.opd_patient_title||''} ${row.opd_patient_name||''}`.trim(), sortable:true, width:'170px' },
  
  { name:'UHID', selector:row=>row.opd_uhid, sortable:true, width:'130px' },
  { name:'Reg. Number', selector:row=>row.opd_id, sortable:true, width:'120px' },
  { name:'Reg. Date', selector:row=>formatDateTime(row.opd_datetime), sortable:true, width:'190px' },
  
  { name:'Consult Doctor', selector:row=>row.consult_doctor_name||getDoctorNameById(row.opd_concult_doctor), sortable:true, wrap:true, width:'190px' },

 

  { name:'OPD Total', selector:row=>row.opd_final_amt, right:true, width:'110px' },
  { 
    name: 'Paid Amount', 
    selector: row => row.opd_paid, 
    right: true, 
    width: '160px',
    cell: row => {
      const paid = parseFloat(row.opd_paid || 0);
      const refunded = parseFloat(opdRefundMap[row.opd_id] || 0);
      
      return (
        <div style={{ textAlign: 'right', width: '100%' }}>
          <div className="text-success fw-semibold">
            ₹{paid.toFixed(2)}
          </div>
          {refunded > 0 && (
            <div style={{ fontSize: '11px', color: '#dc3545', marginTop: 2 }}>
              <i className="ri-refund-2-line" style={{ fontSize: 10 }}></i>
              {' '}Refunded: ₹{refunded.toFixed(2)}
            </div>
          )}
        </div>
      );
    }
  },
  { name:'Due Amount', selector:row=>row.opd_due, right:true, width:'110px' },
  
  { name:'Last Used', selector:row=>resolveUserDisplay(row), sortable:true, width:'160px' },
];

const rows = displayedRows;
const conditionalRowStyles = [
  { 
    when: row => row.opd_type === "Move to IPD", 
    style: {
      backgroundColor: '#d1f5d9',
      borderLeft: '4px solid #198754',
      fontStyle: 'italic',
      color: '#155724'
    }
  }
];
const customStyles = { headCells:{style:{backgroundColor:'#f1f5fb',color:'#405189',fontSize:'15px',fontWeight:'700',paddingLeft:'14px',paddingRight:'14px'}}, rows:{style:{fontSize:'16px',minHeight:'58px'}}, cells:{style:{paddingLeft:'14px',paddingRight:'14px',fontSize:'15px',lineHeight:'25px'}} };

  return (
    <div className="page-content">
<style>{`
  .dropdown-menu.show { z-index: 1040; }
  body:has(.modal.show) .dropdown-menu, body:has(.modal.show) .dropup { display: none !important; visibility: hidden !important; }
`}</style>



<ul className="nav nav-tabs mb-3">
  <li className="nav-item">
    <button className={`nav-link ${activeRegTab==='registration'?'active':''}`}
      onClick={()=>setActiveRegTab('registration')}>
      <i className="ri-hospital-line me-1"></i>OPD Registration
    </button>
  </li>
  <li className="nav-item">
    <button className={`nav-link ${activeRegTab==='slots'?'active':''}`}
      onClick={()=>setActiveRegTab('slots')}>
      <i className="ri-calendar-check-line me-1"></i>Doctor Appointment Slot
    </button>
  </li>
</ul>

{activeRegTab==='registration' ? (
      <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm"><h5 className="card-title mb-0">OPD Registrations</h5></div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <a href="#!" onClick={(e)=>{e.preventDefault();sessionStorage.removeItem("opd_dt");window.location.href="/opd_registrations";}}>
                        <button type="button" className="btn btn-success add-btn"><i className="ri-add-line align-bottom me-1"></i> New Entry</button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                  <div className="col-md-2">
  <label className="form-label">From</label>
  <input className="form-control" type="date" name="from" 
    value={formData.from}
    onChange={(e) => {
      const newFrom = e.target.value;
      setFormData(prev => ({...prev, from: newFrom}));
      setTimeout(() => initData({ from: newFrom, to: formData.to }), 80);  // ✅ pass directly
    }} 
  />
</div>
<div className="col-md-2">
  <label className="form-label">To</label>
  <input className="form-control" type="date" name="to" 
    value={formData.to}
    onChange={(e) => {
      const newTo = e.target.value;
      setFormData(prev => ({...prev, to: newTo}));
      setTimeout(() => initData({ from: formData.from, to: newTo }), 80);  // ✅ pass directly
    }} 
  />
</div>
                    <div className="col-md-2">
                      <label className="form-label"></label>
                      <div style={{display:"flex"}}>&nbsp;&nbsp;<button type="button" onClick={()=>{setFormData(prev=>({...prev,search_key:"",from:todayDate,to:todayDate}));setTimeout(initData,100);}} className="btn btn-info">Clear</button></div>
                    </div>
                    <div className="col-md-3" style={{zIndex:1050}}>
                      <label className="form-label">Doctor</label>
                      <Select options={doctorOptions} value={doctorOptions.find(opt=>String(opt.value)===String(formData.selectedDoctorId))||null} onChange={(so)=>{if(isDoctorLogin)return;setFormData(prev=>({...prev,selectedDoctorId:so?so.value:''}));}} placeholder={isDoctorLogin?"Doctor (Locked)":"All Doctors"} isClearable={!isDoctorLogin} isSearchable={!isDoctorLogin} isDisabled={isDoctorLogin} />
                    </div>
                    <div className="col-md-3" style={{textAlign:"right"}}>
                      <label className="form-label"></label>
                      <div className="search-box">
                        <input className="form-control search" placeholder="Search..." type="text" name="search_key" onChange={(e)=>setFormData(prev=>({...prev,search_key:e.target.value}))} value={formData.search_key} />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div className="table-responsive table-card mb-1" style={{ maxHeight: '600px', overflow: 'auto' }} >
                  <DataTable columns={columns} data={rows} customStyles={customStyles} className="opd-table" noHeader pagination paginationServer paginationPerPage={pageSize} paginationRowsPerPageOptions={[15,20,25,50]} paginationTotalRows={totalCount} paginationDefaultPage={pageNo+1}
                    onChangePage={(newPage)=>{const z=Math.max(0,newPage-1);setPageNo(z);initData({page:z,size:pageSize});}}
                    onChangeRowsPerPage={(newPerPage,newPage)=>{const z=Math.max(0,(newPage?newPage-1:0));setPageSize(newPerPage);setPageNo(z);initData({page:z,size:newPerPage});}}
                    highlightOnHover conditionalRowStyles={conditionalRowStyles} persistTableHead expandableRows expandableRowsComponent={ExpandedActions} expandableRowExpanded={()=>true} expandOnRowClicked={false}
                  />
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="text-muted">
                    <strong>Total:</strong> {totals.totalAmount.toFixed(2)} | <strong>Discount:</strong> {totals.discountAmount.toFixed(2)} | <strong>Paid:</strong> {totals.paidAmount.toFixed(2)} | <strong>Due:</strong> {totals.dueAmount.toFixed(2)} | <strong>Reg Charges:</strong> {totals.totalCharges.toFixed(2)}
                    {totals.procBillAmount > 0 && <> | <strong>Proc Bill:</strong> {totals.procBillAmount.toFixed(2)}</>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showProcedureBill && procedurePatientData && (
        <ProcedureBillModal patientData={procedurePatientData} onClose={()=>{setShowProcedureBill(false);setProcedurePatientData(null);setOpenDropdownId(null);setTimeout(()=>{initData({page:pageNo,size:pageSize});},100);}} image={headerLogo} watermarkImage={watermarkLogo} footerImage={footerImage} />
      )}

      {/* ============================================================ */}
      {/* ✅ LAB REGISTRATION PICKER MODAL (when multiple lab regs for same UHID) */}
      {/* ============================================================ */}
      {showLabRegPickerModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor:"rgba(0,0,0,0.5)", zIndex:9999 }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Select Lab Registration — {labRegPickerOpdRow?.opd_patient_name || 'Patient'} ({labRegPickerOpdRow?.opd_uhid || ''})
                </h5>
                <button type="button" className="btn-close" onClick={()=>setShowLabRegPickerModal(false)}></button>
              </div>
              <div className="modal-body">
                <p className="text-muted mb-3">This patient has <strong>{labRegPickerList.length}</strong> lab registrations. Select one to view/print:</p>
                <div style={{ maxHeight:'400px', overflowY:'auto' }}>
                  <table className="table table-hover table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th style={{width:'50px'}}>#</th>
                        <th>Reg ID</th>
                        <th>Date & Time</th>
                        <th>Status</th>
                        <th>Tests</th>
                        <th style={{width:'100px'}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {labRegPickerList.map((reg, idx) => {
                        const st = (reg.lab_reg_status||'').toLowerCase();
                        const isCompleted = st === 'completed';
                        const due = Number(reg.lab_due || 0);
                        return (
                          <tr key={reg.lab_reg_id || idx}>
                            <td>{idx + 1}</td>
                            <td><strong>{reg.lab_reg_id}</strong></td>
                            <td>{formatDateTime(reg.lab_reg_datetime || reg.lab_reg_date)}</td>
                            <td>
                              <span className={`badge ${st==='completed'?'bg-success':st==='pending'?'bg-danger':st==='sample collected'?'bg-warning text-dark':'bg-secondary'}`}>
                                {reg.lab_reg_status || 'Unknown'}
                              </span>
                              {isCompleted && due > 0 && <span className="badge bg-info ms-1">Due: ₹{due.toFixed(0)}</span>}
                            </td>
                            <td style={{maxWidth:'200px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                              {reg.displayTestNames || '-'}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-primary"
                                disabled={!isCompleted || due > 0}
                                title={!isCompleted ? "Not completed yet" : due > 0 ? `Due: ₹${due.toFixed(2)}` : "Print Report"}
                                onClick={() => openLabTestSelectionModal(labRegPickerOpdRow, reg)}
                              >
                                <i className="ri-printer-fill me-1"></i>Print
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowLabRegPickerModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============================================================ */}
      {/* ✅ LAB REPORT TEST SELECTION MODAL (select tests → print PDF) */}
      {/* ============================================================ */}
      {showLabReportModal && labReportModalData && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor:"rgba(0,0,0,0.5)", zIndex:9999 }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Select Tests to Print — {labReportModalData.patient?.lab_reg_name || ''}
                </h5>
                <button type="button" className="btn-close" onClick={()=>setShowLabReportModal(false)}></button>
              </div>
              <div className="modal-body">
                {/* Patient info bar */}
                <div className="alert alert-info py-2 mb-3">
                  <strong>UHID:</strong> {labReportModalData.patient?.lab_reg_uhid || '-'} &nbsp;|&nbsp;
                  <strong>Reg ID:</strong> {labReportModalData.labReg?.lab_reg_id || '-'} &nbsp;|&nbsp;
                  <strong>Date:</strong> {formatDateTime(labReportModalData.labReg?.lab_reg_datetime || labReportModalData.labReg?.lab_reg_date)}
                </div>

                {/* Select All */}
                <div className="mb-3 d-flex align-items-center" style={{ gap:8 }}>
                  <input type="checkbox" id="lab-select-all" checked={labReportSelectAll} onChange={handleLabTestSelectAll} />
                  <label htmlFor="lab-select-all" style={{ margin:0, fontWeight:600 }}>Select All ({labReportModalData.tests?.length || 0} tests)</label>
                </div>
                <hr />

                {/* Test list */}
                <div style={{ maxHeight:350, overflowY:'auto', paddingRight:8 }}>
                  {(labReportModalData.tests || []).map((test, idx) => {
                    const id = String(test.id);
                    const label = test.lab_item_test_name || test.name || `Test ${idx+1}`;
                    const paramCount = test.params?.length || 0;
                    const hasResults = test.params?.some(p => p.result && String(p.result).trim() !== '') || false;
                    const isApproved = test.report_info?.is_approved === "1" || test.is_approved === "1" || test.is_approved === 1;

                    return (
                      <div key={id} className="mb-2 d-flex align-items-start p-2" style={{
                        border:'1px solid #e0e0e0', borderRadius:4,
                        backgroundColor: !isApproved ? '#fff8e1' : (labReportSelectedTests.includes(id) ? '#f0f8ff' : '#fff'),
                        opacity: !isApproved ? 0.7 : 1
                      }}>
                        <input
                          type="checkbox"
                          id={`lab-test-${id}`}
                          checked={labReportSelectedTests.includes(id)}
                          onChange={() => handleLabTestToggle(id)}
                          disabled={!isApproved}
                          style={{ marginRight:8, marginTop:4 }}
                        />
                        <label htmlFor={`lab-test-${id}`} style={{ margin:0, cursor:isApproved?'pointer':'not-allowed', flex:1 }}>
                          <div style={{ fontWeight:500, display:'flex', alignItems:'center', gap:8 }}>
                            {label}
                            {isApproved ? <span className="badge bg-success">Approved</span> : <span className="badge bg-warning text-dark">Not Approved</span>}
                          </div>
                          <small style={{ color: paramCount > 0 ? '#28a745' : '#dc3545' }}>
                            {paramCount} param{paramCount!==1?'s':''}
                            {hasResults && ' • Has results'}
                            {!isApproved && ' • Cannot print until approved'}
                          </small>
                        </label>
                      </div>
                    );
                  })}
                </div>

                {labReportSelectedTests.length === 0 && (
                  <div className="alert alert-warning mt-3">Please select at least one approved test to print</div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowLabReportModal(false)}>Cancel</button>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={labReportSelectedTests.length === 0}
                  onClick={handleLabReportPrint}
                >
                  <i className="ri-printer-line me-2"></i>
                  Print Selected ({labReportSelectedTests.length})
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

</>
    ) : (
      <DoctorAppointmentSlot parentDoctors={formData.doc} />
    )}



{/* ✅ PAYMENT MODAL - Add this before your closing </div> tags */}
{showPaymentModal && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ 
    backgroundColor: 'rgba(0,0,0,0.5)', 
    zIndex: 9999 
  }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header" style={{ 
          background: 'linear-gradient(135deg, #405189 0%, #6366f1 100%)', 
          color: 'white' 
        }}>
          <h5 className="modal-title">
            <i className="ri-money-rupee-circle-line me-2" />
            Collect Payment
          </h5>
          <button 
            type="button" 
            className="btn-close btn-close-white" 
            onClick={() => setShowPaymentModal(false)}
            disabled={paymentProcessing}>
          </button>
        </div>
        
        <div className="modal-body">
          {paymentPatient && (
            <>
              {/* Patient Info */}
              <div className="mb-3 p-3 bg-light rounded">
                <div className="row">
                  <div className="col-6">
                    <small className="text-muted">Patient Name</small>
                    <div className="fw-semibold">
                      {paymentPatient.opd_patient_title} {paymentPatient.opd_patient_name}
                    </div>
                  </div>
                  <div className="col-6">
                    <small className="text-muted">UHID</small>
                    <div className="fw-semibold">{paymentPatient.opd_uhid}</div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6">
                    <small className="text-muted">Total Charges</small>
                    <div className="fw-semibold text-primary">
                      ₹{parseFloat(paymentPatient.opd_final_amt || 0).toFixed(2)}
                    </div>
                  </div>
                  <div className="col-6">
                    <small className="text-muted">Due Amount</small>
                    <div className="fw-bold text-danger">
                      ₹{parseFloat(paymentPatient.opd_due || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
 
              {/* Payment Amount */}
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Payment Amount <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter amount"
                  value={paymentAmount}
                  onChange={(e) => setPaymentAmount(e.target.value)}
                  min="0"
                  max={parseFloat(paymentPatient.opd_due || 0)}
                  step="0.01"
                />
                <small className="text-muted">
                  Maximum: ₹{parseFloat(paymentPatient.opd_due || 0).toFixed(2)}
                </small>
              </div>
 
              {/* Payment Mode */}
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Payment Mode <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}>
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="Online">Online/UPI</option>
                  <option value="Cheque">Cheque</option>
                </select>
              </div>
            </>
          )}
        </div>
        
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowPaymentModal(false)}
            disabled={paymentProcessing}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={handleProcessPayment}
            disabled={paymentProcessing}>
            {paymentProcessing ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Processing...
              </>
            ) : (
              <>
                <i className="ri-check-line me-1" />
                Confirm Payment
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}


{/* ✅ OPD REFUND MODAL */}
{showOpdRefundModal && opdRefundPatient && (
  <div className="modal fade show d-block" tabIndex="-1" 
       style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
    <div className="modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header" style={{ 
          background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)', 
          color: 'white' 
        }}>
          <h5 className="modal-title">
            <i className="ri-refund-2-line me-2"></i>
            Process Refund
          </h5>
          <button type="button" className="btn-close btn-close-white"
                  onClick={() => setShowOpdRefundModal(false)}
                  disabled={opdRefundProcessing}></button>
        </div>

        <div className="modal-body">
          {/* Patient Info */}
          <div className="mb-3 p-3 bg-light rounded">
            <div className="row">
              <div className="col-6">
                <small className="text-muted">Patient Name</small>
                <div className="fw-semibold">
                  {opdRefundPatient.opd_patient_title} {opdRefundPatient.opd_patient_name}
                </div>
              </div>
              <div className="col-6">
                <small className="text-muted">UHID</small>
                <div className="fw-semibold">{opdRefundPatient.opd_uhid}</div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-4">
                <small className="text-muted">Total</small>
                <div className="fw-semibold text-primary">
                  ₹{parseFloat(opdRefundPatient.opd_final_amt || 0).toFixed(2)}
                </div>
              </div>
              <div className="col-4">
                <small className="text-muted">Paid</small>
                <div className="fw-bold text-success">
                  ₹{parseFloat(opdRefundPatient.opd_paid || 0).toFixed(2)}
                </div>
              </div>
              <div className="col-4">
                <small className="text-muted">Due</small>
                <div className="fw-bold text-danger">
                  ₹{parseFloat(opdRefundPatient.opd_due || 0).toFixed(2)}
                </div>
              </div>
            </div>
          </div>

          {/* Refund Form */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">
                Refund Mode <span className="text-danger">*</span>
              </label>
              <select className="form-select"
                      value={opdRefundMode}
                      onChange={(e) => setOpdRefundMode(e.target.value)}>
                <option value="" disabled>-- Select Mode --</option>
                <option value="Cash">Cash</option>
                <option value="Online">Online</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">
                Refund Amount <span className="text-danger">*</span>
              </label>
              <input type="number" className="form-control"
                     placeholder="Enter amount"
                     value={opdRefundAmount}
                     onChange={(e) => setOpdRefundAmount(e.target.value)}
                     min="0"
                     max={parseFloat(opdRefundPatient.opd_paid || 0)}
                     step="0.01" />
              <small className="text-muted">
                Maximum: ₹{parseFloat(opdRefundPatient.opd_paid || 0).toFixed(2)}
              </small>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label fw-semibold">Refunded By</label>
              <input type="text" className="form-control"
                     value={opdRefundedBy}
                     readOnly
                     style={{ backgroundColor: '#e9ecef' }} />
            </div>

            <div className="col-md-12 mb-3">
              <label className="form-label fw-semibold">
                Remarks <span className="text-danger">*</span>
              </label>
              <textarea className="form-control" rows="2"
                        placeholder="Enter reason for refund (mandatory)"
                        value={opdRefundRemarks}
                        onChange={(e) => setOpdRefundRemarks(e.target.value)}></textarea>
            </div>
          </div>

          {/* Refund History */}
          {opdRefundHistory.length > 0 && (
            <>
              <hr />
              <h6 className="mb-3">Refund History</h6>
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <table className="table table-sm table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Date & Time</th>
                      <th>Mode</th>
                      <th className="text-end">Amount</th>
                      <th>By</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {opdRefundHistory.map((r, idx) => (
                      <tr key={r.refund_id}>
                        <td>{idx + 1}</td>
                        <td>{new Date(r.refund_datetime).toLocaleString()}</td>
                        <td>
                          <span className={`badge ${r.refund_mode === 'Cash' ? 'bg-success' : 'bg-info'}`}>
                            {r.refund_mode}
                          </span>
                        </td>
                        <td className="text-end text-danger fw-bold">
                          -₹{parseFloat(r.refund_amount).toFixed(2)}
                        </td>
                        <td>{r.refunded_by}</td>
                        <td><small>{r.refund_remarks}</small></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary"
                  onClick={() => setShowOpdRefundModal(false)}
                  disabled={opdRefundProcessing}>
            Cancel
          </button>
          <button className="btn btn-danger"
                  onClick={handleProcessOpdRefund}
                  disabled={opdRefundProcessing}>
            {opdRefundProcessing ? (
              <><span className="spinner-border spinner-border-sm me-2"></span>Processing...</>
            ) : (
              <><i className="ri-refund-2-line me-1"></i>Process Refund</>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default OpdPataintList;